import React, { Component } from "react";
import {
  Business,
  AssignmentInd,
  BubbleChart,
  ChangeHistory,
  ChromeReaderMode,
  Email,
  LockOutlined,
  Phone,
  Sms,
  VerifiedUser,
  Visibility,
  VisibilityOff,
  Person,
  PersonAddAlt1,
  PersonOff,
  CheckCircle,
  Cancel,
  Login,
  MailOutline,
  Fingerprint,
  AccountBalanceWallet,
  Add,
  PlayArrow,
  CheckCircleOutline,
  ErrorOutline,
  HourglassEmpty,
  MoreVert,
  RemoveCircleOutline,
  Description,
  Settings,
} from "@mui/icons-material";
import {
  Autocomplete,
  Box,
  Button,
  Chip,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormHelperText,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Tab,
  Tabs,
  TextField,
  Tooltip,
  Checkbox,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Menu,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { connect } from "react-redux";
import {
  adminGetCustomerWallets,
  adminGetCustomerTransactions,
  adminTopUpWallet,
  adminTerminateWallet,
  adminCreateWallets,
  adminCreateCustomWallet,
  adminListPlans,
  adminGetSubscription,
  adminChangeSubscription,
  adminGetBillingSetup,
  adminRunBillingSetup,
  adminRunSmsConfigSetup,
  adminRunLifecycleSetup,
  adminCreatePlan,
  adminUpdatePlan,
  adminDeletePlan,
  adminEditWallet,
  adminVoidWalletCredits,
} from "../../actions/billing";
import {
  getAccountStatus,
  getStatusHistory,
  getAccountSubscriptions,
  getAccountEntitlements,
  transitionAccount,
} from "../../actions/lifecycle";
import {
  getTenantSmsConfig,
  changeDefaultSenderId,
  setDefaultSmsType,
  adminListTemplates,
  adminCreateTemplate,
  adminUpdateTemplate,
  adminDeleteTemplate,
  sendWelcomeEmail,
  ensureOtpMethods,
  listUserSessions,
  terminateUserSession,
  activateTenantUser,
  deactivateTenantUser,
  updateTenantUser,
  updateOrgName,
} from "../../actions/adminPanel";
import {
  getTenantRateLimit,
  setTenantTier,
  setTenantOverride,
  removeTenantOverride,
} from "../../actions/rateLimit";
import {
  Edit as EditIcon,
  Delete as DeleteIcon,
  AddCircleOutline,
  CreditCard,
  Receipt,
  Refresh,
} from "@mui/icons-material";
import { Alert, Card, CardContent, Divider, Typography, Paper } from "@mui/material";
import { fetchOrgProjects } from "../../actions/adminPanel";

import { getFromLocalStorage, dateFormat } from "../../lib/utils";
import { isPlatformAdminRole, isAdminPanelRole, isSupportTierRole } from "../../auth/roles";
import Api from "../../api";
import {
  ADMIN_LIST_TEMPLATES_URL,
  DELETE_SENDER_ID_URL,
} from "../../lib/constant";
import { CREDIT_PRESETS } from "./creditPresets";
import EditSenderIdTmd from "./EditSenderIdTmd";
import DltTmdField from "../../components/DltTmdField";

// Users-tab column preference (per-browser). Username is kept in email
// format and duplicates the contact email for most tenants — and since
// login-with-email is enabled, support rarely needs it. Hidden by default;
// the gear menu in the Users tab toggles it.
const USERS_SHOW_USERNAME_KEY = "adminUsersShowUsernameCol";
const readShowUsernameCol = () => {
  try {
    return window.localStorage.getItem(USERS_SHOW_USERNAME_KEY) === "1";
  } catch {
    return false;
  }
};

const RL_TIERS = ["premium", "gold", "silver", "normal", "unauthenticated"];
const BLANK_RL_OVERRIDE = { scope: "ingress.sms", capacity: "", fillRate: "", fillIntervalSecs: 1, reason: "", expiresAt: "" };
const PROJECTS_TAB_INDEX = 6;
const RATE_LIMITS_TAB_INDEX = 7;
const API_KEYS_TAB_INDEX = 8;
const ROUTING_TAB_INDEX = 9;
const NOTIFICATIONS_TAB_INDEX = 10;
import EditDLT from "./EditDLT";
import ClearDLT from "./ClearDLT";
import WelcomeOffer from "./WelcomeOffer";
import AdminApiKeysTab from "./ApiKeysTab";
import SentEmailsTab from "../EmailTemplates/SentEmailsTab";
import { canViewNotifications } from "../../lib/notifications";
import AdminRoutingTab from "./RoutingTab";
import AddBalance from "./addBalance";
import AddSMSType from "./addSMSType";
import AddSenderId from "./addSenderId";
import ChangeDefaultSenderId from "./changeDefaultSenderId";
import ChangePassword from "./changePassword";
import ChangeStatus from "./changeStatus";
import COSNTANT from "./constant";

class CustomerDetails extends Component {
  state = {
    activeTab: 1, // Billing — default tab (wallets/plan are the first thing support checks)
    showAddBalance: false,
    showChangeStatus: false,
    showPassword: false,
    showAddSenderId: false,
    showChangeDefaultSenderId: false,
    showAddSMSType: false,
    // Header delete confirm — holds the sender-id row pending deletion.
    deleteHeaderTarget: null,
    deleteHeaderBusy: false,
    showEditDLTId: false,
    showClearDLTId: false,
    // Per-header downstream TMD edit — holds the sender-id row being edited.
    editTmdTarget: null,
    // Template management
    showTemplateForm: false,
    editingTemplate: null,
    showDeleteTemplate: false,
    deleteTemplateTarget: null,
    tplName: "",
    tplText: "",
    tplSenderId: "",
    tplDltId: "",
    tplIndustry: "",
    tplTmdOverride: "",
    tplSaving: false,
    // Rate limits
    rlTierDialog: { open: false, tier: "normal" },
    rlOverrideDialog: { open: false, form: { ...BLANK_RL_OVERRIDE } },
    // Projects tab — lazy-loaded on first activation. `loaded` flips true
    // after the fetch settles (success or error) so re-clicking the tab
    // doesn't refetch.
    projects: [],
    projectsLoading: false,
    projectsError: null,
    projectsLoaded: false,
    // Per-user zitadel sessions dialog (session v2 list + terminate) —
    // server-side half of the single-account rollout.
    //   shape: { userId, displayName, loading, error, sessions, busyId, terminatingAll }
    userSessions: null,
    // Per-user "Send Welcome Email" confirm dialog (the only account email
    // left after the OTP-only cutover — replaces the retired reset-password
    // action). Backend enforces a 5-min cooldown → 429.
    //   shape: { userId, email, displayName, busy }
    welcomeEmailConfirm: null,
    // Per-user IAM activate/deactivate confirm.
    // See docs/ADR_TENANT_STATUS_AND_TIER.md for why this is
    // distinct from the account-tab tenant-level status flip.
    //   shape: { kind: 'activate'|'deactivate', userId, email, displayName, busy }
    userStateConfirm: null,
    // Per-user profile edit dialog (name / email / phone). Zitadel
    // write-through via UpdateTenantUser. Changing the email does NOT
    // change the login username (frozen at creation).
    //   shape: { userId, fullName, email, phone, busy, error }
    userEditDialog: null,
    orgNameDialog: null,
    // Users tab column settings (gear icon in the tab's top-right).
    showUsernameCol: readShowUsernameCol(),
    usersColMenuAnchor: null,
  };

  componentDidMount() {
    // Fetch users for this org when dialog opens
    if (this.props.getTenantUsers && this.props.data?.instituteId) {
      this.props.getTenantUsers(this.props.data.instituteId);
    }
    // Fetch wallets, plans, subscription, and billing setup for tabs
    if (this.props.data?.instituteId) {
      this.props.adminGetCustomerWallets(this.props.data.instituteId, "sms");
      this.props.adminGetCustomerTransactions(this.props.data.instituteId, "");
      this.props.adminListPlans();
      this.props.adminGetSubscription(this.props.data.instituteId);
      this.props.adminGetBillingSetup(this.props.data.instituteId);
      // Fetch lifecycle data
      this.props.getAccountStatus(this.props.data.instituteId);
      this.props.getStatusHistory(this.props.data.instituteId);
      this.props.getAccountSubscriptions(this.props.data.instituteId);
      this.props.getAccountEntitlements(this.props.data.instituteId);
      // Fetch SMS config (sender IDs + message types)
      this.props.getTenantSmsConfig(this.props.data.instituteId);
      // Fetch templates
      this.props.adminListTemplates(this.props.data.instituteId);
      // Fetch tenant rate-limit (tier + active overrides)
      this.props.getTenantRateLimit(this.props.data.instituteId);
    }
  }

  // ── Rate Limits tab handlers ─────────────────────────────────────────
  openRlTierDialog = () => {
    const tier = this.props.tenantRateLimit?.data?.tenant?.rateLimitTier || "normal";
    this.setState({ rlTierDialog: { open: true, tier } });
  };
  closeRlTierDialog = () => this.setState({ rlTierDialog: { open: false, tier: "normal" } });
  submitRlTier = async () => {
    const tenantId = this.props.data?.instituteId;
    if (!tenantId) return;
    await this.props.setTenantTier(tenantId, { tier: this.state.rlTierDialog.tier });
    this.closeRlTierDialog();
    this.props.getTenantRateLimit(tenantId);
  };

  openRlOverrideDialog = () => this.setState({
    rlOverrideDialog: { open: true, form: { ...BLANK_RL_OVERRIDE } },
  });
  closeRlOverrideDialog = () => this.setState({
    rlOverrideDialog: { open: false, form: { ...BLANK_RL_OVERRIDE } },
  });
  submitRlOverride = async () => {
    const tenantId = this.props.data?.instituteId;
    if (!tenantId) return;
    const { form } = this.state.rlOverrideDialog;
    await this.props.setTenantOverride(tenantId, {
      scope: form.scope,
      capacity: parseInt(form.capacity, 10),
      fillRate: parseInt(form.fillRate, 10),
      fillIntervalSecs: parseInt(form.fillIntervalSecs, 10) || 1,
      reason: form.reason || undefined,
      expiresAt: form.expiresAt || undefined,
    });
    this.closeRlOverrideDialog();
    this.props.getTenantRateLimit(tenantId);
  };

  removeRlOverride = async (scope) => {
    const tenantId = this.props.data?.instituteId;
    if (!tenantId) return;
    if (!window.confirm(`Remove override for ${scope}? Tenant will revert to the tier template.`)) return;
    await this.props.removeTenantOverride(tenantId, scope);
    this.props.getTenantRateLimit(tenantId);
  };

  handleTabChange = (e, newValue) => {
    this.setState({ activeTab: newValue });
    if (newValue === PROJECTS_TAB_INDEX && !this.state.projectsLoaded && !this.state.projectsLoading) {
      this.loadProjects();
    }
  };

  loadProjects = async () => {
    const orgId = this.props.data?.instituteId;
    if (!orgId) return;
    this.setState({ projectsLoading: true, projectsError: null });
    try {
      const resp = await fetchOrgProjects(orgId);
      const projects = resp?.data?.projects || [];
      this.setState({ projects, projectsLoading: false, projectsLoaded: true });
    } catch (err) {
      const msg = err?.response?.data?.message || err?.message || "Failed to load projects";
      this.setState({ projectsError: msg, projectsLoading: false, projectsLoaded: true });
    }
  };

  renderProjectsTab() {
    const { projects, projectsLoading, projectsError, projectsLoaded } = this.state;

    if (projectsLoading || !projectsLoaded) {
      return (
        <div style={{ display: "flex", justifyContent: "center", padding: 32 }}>
          <CircularProgress />
        </div>
      );
    }

    if (projectsError) {
      return <p style={{ color: "red", padding: 16 }}>{projectsError}</p>;
    }

    if (projects.length === 0) {
      return (
        <p style={{ color: "rgba(0,0,0,0.54)", padding: 16 }}>
          No projects found in this organization.
        </p>
      );
    }

    return (
      <div style={{ overflowX: "auto" }}>
        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 14 }}>
          <thead>
            <tr style={{ borderBottom: "2px solid #e0e0e0", textAlign: "left" }}>
              <th style={{ padding: "8px 12px" }}>Project Name</th>
              <th style={{ padding: "8px 12px" }}>Project ID</th>
              <th style={{ padding: "8px 12px" }}>State</th>
            </tr>
          </thead>
          <tbody>
            {projects.map((p) => {
              const projectId = p.projectId || p.project_id;
              const projectName = p.projectName || p.project_name;
              const state = p.state || "";
              const isActive = state === "PROJECT_STATE_ACTIVE";
              return (
                <tr key={projectId} style={{ borderBottom: "1px solid #f0f0f0" }}>
                  <td style={{ padding: "8px 12px" }}>{projectName || "-"}</td>
                  <td style={{ padding: "8px 12px", fontFamily: "monospace", fontSize: 12 }}>
                    {projectId}
                  </td>
                  <td style={{ padding: "8px 12px" }}>
                    <Chip
                      size="small"
                      label={state.replace("PROJECT_STATE_", "").toLowerCase() || "unknown"}
                      color={isActive ? "success" : "default"}
                      variant="outlined"
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }

  closeAddBalance = () => this.setState({ showAddBalance: false });
  closeChangeStatus = () => this.setState({ showChangeStatus: false });
  openAddBalance = () => this.setState({ showAddBalance: true });
  openAddSMSType = () => this.setState({ showAddSMSType: true });
  openChangeStatus = () => this.setState({ showChangeStatus: true });
  openAddSenderId = () => this.setState({ showAddSenderId: true });
  toggleEditDLTId = () =>
    this.setState((prev) => ({ showEditDLTId: !prev.showEditDLTId }));
  toggleClearDLTId = () =>
    this.setState((prev) => ({ showClearDLTId: !prev.showClearDLTId }));
  closeAddSenderId = () => this.setState({ showAddSenderId: false });
  closeAddSMSType = () => this.setState({ showAddSMSType: false });
  openChangeDefaultSenderId = () =>
    this.setState({ showChangeDefaultSenderId: true });
  closeChangeDefaultSenderId = () =>
    this.setState({ showChangeDefaultSenderId: false });
  openDeleteHeader = (sid) => this.setState({ deleteHeaderTarget: sid });
  closeDeleteHeader = () => {
    if (this.state.deleteHeaderBusy) return;
    this.setState({ deleteHeaderTarget: null });
  };
  getAdminTemplates = () =>
    this.props.adminTemplates?.templates ||
    this.props.adminTemplates?.data?.templates ||
    this.props.adminTemplates?.data?.list ||
    [];
  // Templates reference a header via sender_id_ref (FK to sms_sender_ids.id);
  // older rows may only carry the human-readable senderId string.
  templatesForHeader = (sid) =>
    this.getAdminTemplates().filter((tpl) => {
      const ref = tpl.senderIdRef || tpl.sender_id_ref;
      const name = tpl.senderId || tpl.sender_id;
      return (ref && sid.id && ref === sid.id) || (name && name === sid.senderId);
    });
  confirmDeleteHeader = async () => {
    const sid = this.state.deleteHeaderTarget;
    if (!sid || this.state.deleteHeaderBusy) return;
    if (sid.isDefault) {
      alert("Default header cannot be deleted, please set another header as default first.");
      return;
    }
    const tenantId = this.props.data.instituteId;
    const templates = this.templatesForHeader(sid);
    this.setState({ deleteHeaderBusy: true });
    try {
      // The backend rejects the header delete while templates still hold an
      // FK to it, so remove the dependent templates first.
      const tplBase = ADMIN_LIST_TEMPLATES_URL.replace("{tenantId}", tenantId);
      for (const tpl of templates) {
        await Api.delete(`${tplBase}/${tpl.id}`);
      }
      const url = DELETE_SENDER_ID_URL.replace("{instId}", tenantId).replace(
        "{senderid}",
        encodeURIComponent(sid.senderId),
      );
      const { data } = await Api.delete(url);
      if (data && data.success === false) {
        throw new Error(data.message || "Failed to delete header");
      }
      this.setState({ deleteHeaderTarget: null, deleteHeaderBusy: false });
      this.props.getTenantSmsConfig(tenantId);
      this.props.adminListTemplates(tenantId);
    } catch (err) {
      this.setState({ deleteHeaderBusy: false });
      // Some templates may already be gone — refresh so the list is honest.
      this.props.adminListTemplates(tenantId);
      alert(
        err?.response?.data?.message ||
          err?.message ||
          "Failed to delete header, please try again.",
      );
    }
  };
  addBalance = (params) => {
    this.setState({ showAddBalance: false });
    this.props.addBalance(params);
  };
  addSMSType = (params) => {
    this.setState({ showAddSMSType: false });
    this.props.addSMSType(params);
  };
  changeStatus = (params) => {
    this.setState({ showChangeStatus: false });
    this.props.changeStatus(params);
  };
  addSenderId = (params) => {
    this.setState({ showAddSenderId: false });
    this.props.addSenderId(params);
  };
  onDltUpdateSuccess = () => {
    this.setState({ showEditDLTId: false, showClearDLTId: false });
    this.props.getTenantSmsConfig(this.props.data.instituteId);
  };
  openEditSenderIdTmd = (sid) => this.setState({editTmdTarget: sid});
  closeEditSenderIdTmd = () => this.setState({editTmdTarget: null});
  onSenderIdTmdUpdateSuccess = () => {
    this.closeEditSenderIdTmd();
    this.props.getTenantSmsConfig(this.props.data.instituteId);
  };
  changeDefaultSenderId = (params) => {
    this.setState({ showChangeDefaultSenderId: false });
    this.props.changeDefaultSenderId(this.props.data.instituteId, params);
    setTimeout(
      () => this.props.getTenantSmsConfig(this.props.data.instituteId),
      500,
    );
  };
  handleSetDefaultSenderId = (senderId) => {
    this.props.changeDefaultSenderId(this.props.data.instituteId, {
      sender_id: senderId,
    });
    setTimeout(
      () => this.props.getTenantSmsConfig(this.props.data.instituteId),
      500,
    );
  };
  handleSetDefaultSmsType = (smsType) => {
    this.props.setDefaultSmsType(this.props.data.instituteId, smsType);
    setTimeout(
      () => this.props.getTenantSmsConfig(this.props.data.instituteId),
      500,
    );
  };
  // Template handlers
  openAddTemplate = () => {
    this.setState({
      showTemplateForm: true,
      editingTemplate: null,
      tplName: "",
      tplText: "",
      tplSenderId: "",
      tplDltId: "",
      tplIndustry: "",
      tplTmdOverride: "",
    });
  };
  openEditTemplate = (tpl) => {
    this.setState({
      showTemplateForm: true,
      editingTemplate: tpl,
      tplName: tpl.templateName || tpl.template_name || "",
      tplText: tpl.templateText || tpl.template_text || "",
      // sender_id_ref is the FK to sms_sender_ids.id — match the dropdown
      // option value (sid.id), NOT the human-readable senderId string.
      tplSenderId:
        tpl.senderIdRef ||
        tpl.sender_id_ref ||
        tpl.senderId ||
        tpl.sender_id ||
        "",
      tplDltId: tpl.dltTemplateId || tpl.dlt_template_id || "",
      // Industry category (promotional, mandatory per TRAI since 14 Jul 2026).
      tplIndustry:
        (tpl.metadata &&
          (tpl.metadata.industry_category || tpl.metadata.industryCategory)) ||
        "",
      tplTmdOverride: tpl.dltTmdIdOverride || tpl.dlt_tmd_id_override || "",
    });
  };
  closeTemplateForm = () =>
    this.setState({
      showTemplateForm: false,
      editingTemplate: null,
      tplSaving: false,
    });
  // Promotional traffic is whatever rides a numeric-header sender — there is
  // no DLT category anywhere any more (backend removed it 2026-08-01); this
  // only gates the promotional-only extras (industry category, consent).
  isPromoSender = () => {
    const smsConfig = this.state.smsConfig || {};
    const senders = smsConfig.senderIds || smsConfig.sender_ids || [];
    const sel = senders.find((sid) => sid.id === this.state.tplSenderId);
    const ht = String(sel?.headerType || sel?.header_type || "").toUpperCase();
    return ht.includes("NUMERIC") && !ht.includes("ALPHA");
  };

  saveTemplate = () => {
    const {
      tplName,
      tplText,
      tplSenderId,
      tplDltId,
      tplIndustry,
      tplTmdOverride,
      editingTemplate,
    } = this.state;
    if (!tplName || !tplText || !tplSenderId || !tplDltId) {
      alert("All fields are required");
      return;
    }
    // Promotional (numeric-header) templates must carry a DLT Industry
    // Category (TRAI mandate effective 14 Jul 2026).
    const isPromotional = this.isPromoSender();
    if (isPromotional && !String(tplIndustry || "").trim()) {
      alert("Industry Category is required for numeric-header (promotional) templates (TRAI DLT rule, effective 14 Jul 2026).");
      return;
    }
    const params = {
      templateName: tplName,
      templateText: tplText,
      senderIdRef: tplSenderId,
      dltTemplateId: tplDltId,
      // Internal only — buildAdminTemplateParams uses this to decide the
      // promotional-only extras; it is not sent on the wire.
      isPromotional,
      industryCategory: isPromotional ? String(tplIndustry).trim() : "",
      dltTmdIdOverride: String(tplTmdOverride || "").trim(),
    };
    this.setState({ tplSaving: true });
    const tenantId = this.props.data.instituteId;
    if (editingTemplate) {
      this.props.adminUpdateTemplate(tenantId, editingTemplate.id, params);
    } else {
      this.props.adminCreateTemplate(tenantId, params);
    }
    setTimeout(() => {
      this.props.adminListTemplates(tenantId);
      this.setState({
        showTemplateForm: false,
        editingTemplate: null,
        tplSaving: false,
      });
    }, 600);
  };
  openDeleteTemplate = (tpl) =>
    this.setState({ showDeleteTemplate: true, deleteTemplateTarget: tpl });
  confirmDeleteTemplate = () => {
    const { deleteTemplateTarget } = this.state;
    if (!deleteTemplateTarget) return;
    const tenantId = this.props.data.instituteId;
    this.props.adminDeleteTemplate(tenantId, deleteTemplateTarget.id);
    this.setState({ showDeleteTemplate: false, deleteTemplateTarget: null });
    setTimeout(() => this.props.adminListTemplates(tenantId), 500);
  };
  closeDeleteTemplate = () =>
    this.setState({ showDeleteTemplate: false, deleteTemplateTarget: null });

  openChangePassword = () => this.setState({ showChangePassword: true });
  changePassword = (params) => {
    this.setState({ showChangePassword: false });
    this.props.changePassword(params);
  };
  closeChangePassword = () => this.setState({ showChangePassword: false });
  togglePassword = (e) => {
    e.stopPropagation();
    this.setState({ showPassword: !this.state.showPassword });
  };
  handleIconClick = (e) => e.stopPropagation();

  handleRunBillingSetup = () => {
    const { data } = this.props;
    this.setState({ onboardingSetupLoading: true });
    this.props.adminRunBillingSetup(data.instituteId);
    // Refresh status after a delay
    setTimeout(() => {
      this.props.adminGetBillingSetup(data.instituteId);
      this.setState({ onboardingSetupLoading: false });
    }, 3000);
  };

  handleRunSmsConfigSetup = () => {
    const { data } = this.props;
    this.setState({ smsSetupLoading: true });
    this.props.adminRunSmsConfigSetup(data.instituteId);
    // Refresh the SMS config (sender ids / templates) after a delay
    setTimeout(() => {
      this.props.getTenantSmsConfig(data.instituteId);
      this.setState({ smsSetupLoading: false });
    }, 3000);
  };

  // Create the billing-layer lifecycle account in TRIAL for a tenant that
  // bypassed onboarding's stepLifecycle (no account row yet). Billing layer
  // only — independent of IAM state and rate-limit tier.
  handleRunLifecycleSetup = () => {
    const { data } = this.props;
    this.setState({ lifecycleSetupLoading: true });
    this.props.adminRunLifecycleSetup(data.instituteId);
    setTimeout(() => {
      this.props.getAccountStatus(data.instituteId);
      this.setState({ lifecycleSetupLoading: false });
    }, 3000);
  };

  renderOnboardingTab() {
    const { adminBillingSetup, tenantSmsConfig, tenantUsersRes, data } = this.props;
    const { onboardingSetupLoading, smsSetupLoading } = this.state;
    const setup = adminBillingSetup;
    const isLoading = !setup;

    const stepIcon = (done) =>
      done ? (
        <CheckCircleOutline style={{ color: "green", fontSize: 18 }} />
      ) : (
        <HourglassEmpty style={{ color: "#bbb", fontSize: 18 }} />
      );

    const billingReady = setup?.status === "ready";
    const billingSubSteps = [
      { label: "Organization", key: "billingOrgExists" },
      { label: "Customer", key: "customerExists" },
      { label: "Seeded Default Plans", key: "plansSeeded" },
      { label: "Subscription", key: "subscriptionCreated" },
      { label: "Wallet", key: "walletCreated" },
    ];

    // SMS Config readiness — read from the same source the SMS Config tab
    // uses (tenantSmsConfig prop is the live /tenants/{id}/sms-config API
    // response). Previously this read this.state.senderIds, which is local
    // form state that only populates when the operator opens the Add-Sender
    // form, so the Onboarding tab showed "Pending" indefinitely even when
    // the seed had created the sender. Now mirrors the SMS Config tab's
    // unwrap chain so the green check appears the moment data lands.
    const smsConfigResp = tenantSmsConfig?.data || tenantSmsConfig || {};
    const smsConfigData = smsConfigResp.data || smsConfigResp;
    const apiSenderIds =
      smsConfigData.senderIds || smsConfigData.sender_ids || [];
    const apiMessageTypes =
      smsConfigData.messageTypes || smsConfigData.message_types || [];
    const dltPrincipalEntityId =
      smsConfigData.dltPrincipalEntityId ||
      smsConfigData.dlt_principal_entity_id ||
      data?.dltPrincipalEntityId;
    // Ready = DLT principal entity ID present AND at least 1 sender id AND
    // at least 1 message type — all three are needed before real sends work.
    const hasSmsConfig =
      !!dltPrincipalEntityId &&
      apiSenderIds.length > 0 &&
      apiMessageTypes.length > 0;
    const smsConfigDoneDesc = (() => {
      const parts = ["DLT ID"];
      parts.push(`${apiSenderIds.length} sender id${apiSenderIds.length > 1 ? "s" : ""}`);
      parts.push(`${apiMessageTypes.length} message type${apiMessageTypes.length > 1 ? "s" : ""}`);
      return `Configured — ${parts.join(", ")}`;
    })();
    const smsConfigPendingDesc = (() => {
      const missing = [];
      if (!dltPrincipalEntityId) missing.push("DLT principal entity ID");
      if (apiSenderIds.length === 0) missing.push("sender id");
      if (apiMessageTypes.length === 0) missing.push("message type");
      return `Pending — missing ${missing.join(", ")}`;
    })();

    // IAM readiness — the org itself already exists (this dialog only opens
    // on a live org), so green hinges on Zitadel having BOTH a human login
    // user and the machine (API) user. Same source as the Users tab.
    const tenantUsers = tenantUsersRes?.success
      ? tenantUsersRes.data?.users || []
      : [];
    const hasHumanUser = tenantUsers.some(
      (u) => (u.userType || u.user_type) !== "machine"
    );
    const hasMachineUser = tenantUsers.some(
      (u) => (u.userType || u.user_type) === "machine"
    );
    const iamReady = hasHumanUser && hasMachineUser;
    const iamPendingDesc = !tenantUsersRes
      ? "Checking Zitadel users…"
      : `Pending — missing ${[
        !hasHumanUser && "human user",
        !hasMachineUser && "machine user",
      ]
        .filter(Boolean)
        .join(" & ")}`;

    const onboardingSteps = [
      { label: "Database", done: true, desc: "Tenant record created" },
      {
        label: "IAM (Zitadel)",
        done: iamReady,
        desc: iamReady
          ? "Organization, human & machine user provisioned"
          : iamPendingDesc,
      },
      {
        label: "SMS Config",
        done: hasSmsConfig,
        desc: hasSmsConfig ? smsConfigDoneDesc : smsConfigPendingDesc,
      },
      {
        label: "Billing",
        done: billingReady,
        desc: "Lago billing organization, customer & plans",
      },
    ];

    return (
      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        {onboardingSteps.map((step, idx) => {
          const isBilling = step.label === "Billing";
          const isSmsConfig = step.label === "SMS Config";
          return (
            <div key={idx}>
              {/* Main step row */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 12,
                  padding: "10px 14px",
                  borderRadius: 8,
                  border: "1px solid #e0e0e0",
                  backgroundColor: step.done ? "#f0fdf4" : "#fff",
                }}
              >
                {step.done ? (
                  <CheckCircleOutline
                    style={{ color: "green", fontSize: 22 }}
                  />
                ) : (
                  <ErrorOutline style={{ color: "#f59e0b", fontSize: 22 }} />
                )}
                <div style={{ flex: 1 }}>
                  <p style={{ fontSize: 14, fontWeight: 500, margin: 0 }}>
                    {step.label}
                  </p>
                  <p
                    style={{
                      fontSize: 12,
                      color: "rgba(0,0,0,0.54)",
                      margin: 0,
                    }}
                  >
                    {step.desc}
                  </p>
                </div>
                <Chip
                  label={step.done ? "Ready" : "Pending"}
                  size="small"
                  color={step.done ? "success" : "warning"}
                  variant="outlined"
                  sx={{ fontSize: 11 }}
                />
              </div>

              {/* Billing sub-steps */}
              {isBilling && (
                <div
                  style={{
                    marginLeft: 28,
                    marginTop: 4,
                    padding: "8px 12px",
                    borderLeft: "2px solid #e0e0e0",
                    borderRadius: "0 0 8px 0",
                  }}
                >
                  {isLoading ? (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 8,
                        padding: 8,
                      }}
                    >
                      <CircularProgress size={16} />{" "}
                      <span style={{ fontSize: 13, color: "#999" }}>
                        Loading...
                      </span>
                    </div>
                  ) : (
                    <>
                      <div
                        style={{
                          display: "flex",
                          gap: 16,
                          flexWrap: "wrap",
                          marginBottom: 8,
                        }}
                      >
                        {billingSubSteps.map((sub) => (
                          <div
                            key={sub.key}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: 6,
                              padding: "4px 10px",
                              borderRadius: 4,
                              backgroundColor: setup[sub.key]
                                ? "#ecfdf5"
                                : "#fafafa",
                            }}
                          >
                            {stepIcon(setup[sub.key])}
                            <span
                              style={{
                                fontSize: 13,
                                color: setup[sub.key] ? "#166534" : "#999",
                              }}
                            >
                              {sub.label}
                            </span>
                          </div>
                        ))}
                      </div>
                      {!billingReady && (
                        <Button
                          variant="contained"
                          size="small"
                          color="primary"
                          startIcon={
                            onboardingSetupLoading ? (
                              <CircularProgress size={14} color="inherit" />
                            ) : (
                              <PlayArrow />
                            )
                          }
                          onClick={this.handleRunBillingSetup}
                          disabled={onboardingSetupLoading}
                          sx={{ fontSize: 12, textTransform: "none" }}
                        >
                          {onboardingSetupLoading
                            ? "Running..."
                            : "Run Billing Setup"}
                        </Button>
                      )}
                    </>
                  )}
                </div>
              )}

              {/* SMS Config setup — seed sender ids/templates from the trial seed */}
              {isSmsConfig && !step.done && (
                <div
                  style={{
                    marginLeft: 28,
                    marginTop: 4,
                    padding: "8px 12px",
                    borderLeft: "2px solid #e0e0e0",
                    borderRadius: "0 0 8px 0",
                  }}
                >
                  <Button
                    variant="contained"
                    size="small"
                    color="primary"
                    startIcon={
                      smsSetupLoading ? (
                        <CircularProgress size={14} color="inherit" />
                      ) : (
                        <PlayArrow />
                      )
                    }
                    onClick={this.handleRunSmsConfigSetup}
                    disabled={smsSetupLoading}
                    sx={{ fontSize: 12, textTransform: "none" }}
                  >
                    {smsSetupLoading ? "Running..." : "Run SMS Config Setup"}
                  </Button>
                </div>
              )}
            </div>
          );
        })}

        {/* SS-13: the offer this org got at signup. Manage = admin + support
            (same audience as Clear DLT ID). */}
        <WelcomeOffer
          tenantId={data.instituteId}
          offer={data.onboarding?.offer}
          canManage={isPlatformAdminRole(this.props.userRole) || isSupportTierRole(this.props.userRole)}
        />
      </div>
    );
  }

  // Welcome email confirm (the only account email left after the OTP-only
  // cutover — replaces the retired reset-password action). Same dialog
  // scaffolding as the retired invite/reset account emails.
  openWelcomeEmailConfirm = (user) => {
    this.setState({
      welcomeEmailConfirm: {
        userId: user.id,
        email: user.email || "",
        displayName: user.fullName || user.full_name || user.email || user.id,
        busy: false,
      },
    });
  };

  closeWelcomeEmailConfirm = () => {
    if (this.state.welcomeEmailConfirm?.busy) return;
    this.setState({ welcomeEmailConfirm: null });
  };

  // Submit welcome email. Backend enforces a 5-minute cooldown per
  // (tenant, user, template) → on 429 we surface the message via alert
  // without closing the dialog so the agent sees the cooldown reason.
  submitWelcomeEmail = async () => {
    const conf = this.state.welcomeEmailConfirm;
    if (!conf) return;
    const tenantId = this.props.data?.instituteId;
    if (!tenantId) {
      alert("Tenant id missing — cannot send.");
      return;
    }
    this.setState({ welcomeEmailConfirm: { ...conf, busy: true } });
    try {
      const res = await sendWelcomeEmail(tenantId, conf.userId);
      const masked = res?.data?.masked_recipient || res?.data?.maskedRecipient || conf.email;
      alert(`Welcome email sent to ${masked}.`);
      this.setState({ welcomeEmailConfirm: null });
    } catch (err) {
      const status = err?.response?.status;
      const body = err?.response?.data;
      let msg;
      if (status === 429) {
        msg = "Cooldown active — try again in a few minutes.";
      } else if (status === 412) {
        msg = "User has no email on file in Zitadel.";
      } else if (status === 404) {
        msg = "User not found in Zitadel.";
      } else {
        msg = body?.message || body?.error || err?.message || "Send failed.";
      }
      alert(msg);
      this.setState({ welcomeEmailConfirm: { ...conf, busy: false } });
    }
  };

  // MANDATE v2: register zitadel OTP auth methods (email/SMS) on one user so
  // code login works. Idempotent — safe to re-click; the alert summarizes
  // which channels are usable and why any were skipped.
  ensureCodeLogin = async (user) => {
    const tenantId = this.props.data?.instituteId;
    if (!tenantId) {
      alert("Tenant id missing.");
      return;
    }
    try {
      const res = await ensureOtpMethods(tenantId, user.id);
      const r = (res?.data?.results || [])[0] || {};
      const channels = [
        (r.otpEmailRegistered ?? r.otp_email_registered) && "email",
        (r.otpSmsRegistered ?? r.otp_sms_registered) && "SMS",
      ].filter(Boolean);
      const skips = [
        r.otpEmailSkippedReason ?? r.otp_email_skipped_reason,
        r.otpSmsSkippedReason ?? r.otp_sms_skipped_reason,
      ].filter(Boolean);
      if (channels.length) {
        alert(`Code login ready via ${channels.join(" + ")}${skips.length ? ` (skipped: ${skips.join(", ")})` : ""}.`);
      } else {
        alert(`Code login NOT enabled — ${skips.join(", ") || "no verified email or phone"}.`);
      }
    } catch (err) {
      const body = err?.response?.data;
      alert(body?.message || body?.error || err?.message || "Enable code login failed.");
    }
  };

  // Zitadel sessions dialog (session v2). List is fetched on open and after
  // every terminate; terminate-all walks the list sequentially so partial
  // failures leave an accurate remainder on refresh.
  openUserSessions = (user) => {
    const displayName = user.fullName || user.full_name || user.email || user.id;
    this.setState(
      { userSessions: { userId: user.id, displayName, loading: true, error: null, sessions: [], busyId: null, terminatingAll: false, showExpired: false } },
      this.refreshUserSessions,
    );
  };

  refreshUserSessions = async () => {
    const cur = this.state.userSessions;
    const tenantId = this.props.data?.instituteId;
    if (!cur || !tenantId) return;
    try {
      const res = await listUserSessions(tenantId, cur.userId);
      const sessions = res?.data?.sessions || [];
      this.setState((prev) => prev.userSessions?.userId === cur.userId
        ? { userSessions: { ...prev.userSessions, loading: false, error: null, sessions, busyId: null, terminatingAll: false } }
        : null);
    } catch (err) {
      const msg = err?.response?.data?.message || err?.message || "Failed to load sessions";
      this.setState((prev) => prev.userSessions?.userId === cur.userId
        ? { userSessions: { ...prev.userSessions, loading: false, error: msg, busyId: null, terminatingAll: false } }
        : null);
    }
  };

  terminateSession = async (sessionId) => {
    const cur = this.state.userSessions;
    const tenantId = this.props.data?.instituteId;
    if (!cur || !tenantId) return;
    this.setState({ userSessions: { ...cur, busyId: sessionId } });
    try {
      await terminateUserSession(tenantId, cur.userId, sessionId);
    } catch (err) {
      alert(err?.response?.data?.message || err?.message || "Terminate failed");
    }
    this.refreshUserSessions();
  };

  // Expired sessions are dead already — terminating them is a no-op, so
  // "Terminate all" only targets the still-active ones.
  isSessionActive = (sess) => {
    if (!sess.expirationDate) return true;
    const d = new Date(sess.expirationDate);
    return isNaN(d.getTime()) || d.getTime() > Date.now();
  };

  terminateAllSessions = async () => {
    const cur = this.state.userSessions;
    const tenantId = this.props.data?.instituteId;
    if (!cur || !tenantId) return;
    const active = cur.sessions.filter(this.isSessionActive);
    if (!active.length) return;
    if (!window.confirm(`Terminate all ${active.length} active session(s) for ${cur.displayName}? The user is signed out everywhere.`)) return;
    this.setState({ userSessions: { ...cur, terminatingAll: true } });
    for (const sess of active) {
      try {
        await terminateUserSession(tenantId, cur.userId, sess.sessionId);
      } catch (err) {
        // keep going — refresh below shows whatever survived
        console.error("terminate session failed", sess.sessionId, err);
      }
    }
    this.refreshUserSessions();
  };

  closeUserSessions = () => {
    const cur = this.state.userSessions;
    if (cur?.busyId || cur?.terminatingAll) return;
    this.setState({ userSessions: null });
  };

  // Per-user IAM state confirm — wraps activate/deactivate. Distinct from
  // the account-status modal on the Account tab: this one mutates the
  // zitadel UserState (IDENTITY layer: login on/off), not the billing
  // account_status. See docs/ADR_TENANT_STATUS_AND_TIER.md.
  openUserStateConfirm = (kind, user) => {
    this.setState({
      userStateConfirm: {
        kind,
        userId: user.id,
        email: user.email || "",
        displayName: user.fullName || user.full_name || user.email || user.id,
        busy: false,
      },
    });
  };

  closeUserStateConfirm = () => {
    if (this.state.userStateConfirm?.busy) return;
    this.setState({ userStateConfirm: null });
  };

  submitUserState = async () => {
    const conf = this.state.userStateConfirm;
    if (!conf) return;
    const tenantId = this.props.data?.instituteId;
    if (!tenantId) {
      alert("Tenant id missing — cannot continue.");
      return;
    }
    this.setState({ userStateConfirm: { ...conf, busy: true } });
    try {
      const fn = conf.kind === "activate" ? activateTenantUser : deactivateTenantUser;
      await fn(tenantId, conf.userId);
      const verb = conf.kind === "activate" ? "Activated" : "Deactivated";
      alert(`${verb} ${conf.displayName}. The user list will refresh.`);
      this.setState({ userStateConfirm: null });
      // Trigger a refresh of the Users tab so the IAM badge + button flip.
      if (typeof this.props.getTenantUsers === "function" && this.props.data?.instituteId) {
        this.props.getTenantUsers(this.props.data.instituteId);
      }
    } catch (err) {
      const statusCode = err?.response?.status;
      const body = err?.response?.data;
      let msg;
      if (statusCode === 404) {
        msg = "User not found in Zitadel.";
      } else if (statusCode === 403) {
        msg = "Not authorized to change this user's IAM state.";
      } else {
        msg = body?.message || body?.error || err?.message || "Operation failed.";
      }
      alert(msg);
      this.setState({ userStateConfirm: { ...conf, busy: false } });
    }
  };

  renderUserStateConfirm() {
    const conf = this.state.userStateConfirm;
    if (!conf) return null;
    const isActivate = conf.kind === "activate";
    const title = isActivate ? "Activate user" : "Deactivate user";
    const verb = isActivate ? "activate" : "deactivate";
    const consequence = isActivate
      ? "They will be able to log in again. No effect on tenant billing status."
      : "They will be blocked from logging in. Existing sessions stay valid until expiry. No effect on tenant billing status.";
    return (
      <Dialog open={true} onClose={this.closeUserStateConfirm}>
        <DialogTitle>{title}</DialogTitle>
        <DialogContent style={{ paddingTop: 16, minWidth: 360 }}>
          <p style={{ margin: 0 }}>
            Are you sure you want to <b>{verb}</b>{" "}
            <b>{conf.displayName}</b>?
          </p>
          <p style={{ marginTop: 8, color: "rgba(0,0,0,0.6)", fontSize: 13 }}>
            {consequence}
          </p>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.closeUserStateConfirm} disabled={conf.busy}>Cancel</Button>
          <Button
            variant="contained"
            color={isActivate ? "success" : "error"}
            onClick={this.submitUserState}
            disabled={conf.busy}
          >
            {conf.busy ? "Working…" : (isActivate ? "Activate" : "Deactivate")}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  // Per-FIELD user edit. Each editable column (Name / Email / Phone) gets
  // its own edit button that opens this single-field dialog. Only the one
  // field is sent to UpdateTenantUser (partial update) — the others are
  // left untouched. `field` is one of: 'fullName' | 'email' | 'phone'.
  // Zitadel write-through; changing email does NOT change the login username.
  USER_EDIT_FIELDS = {
    fullName: { label: "Full Name", apiKey: "full_name", allowEmpty: false },
    email:    { label: "Email", apiKey: "email", allowEmpty: false, type: "email", isEmail: true,
                helper: "Changing the email does not change the login username." },
    phone:    { label: "Phone", apiKey: "phone", allowEmpty: true,
                placeholder: "+919876543210", helper: "E.164 format. Leave blank to clear." },
    username: { label: "Username", apiKey: "username", allowEmpty: false, type: "email", isEmail: true,
                helper: "This is what the user signs in with. Kept in email format; login codes go to the contact email/phone. Independent of the contact email." },
  };

  openUserEditField = (user, field) => {
    const current =
      field === "fullName" ? (user.fullName || user.full_name || "")
      : field === "email"  ? (user.email || "")
      : field === "phone"  ? (user.phone || user.phone_number || "")
      :                      (user.username || user.preferred_login_name || "");
    this.setState({
      userEditDialog: {
        userId: user.id,
        displayName: user.fullName || user.full_name || user.email || user.id,
        field,
        value: current,
        busy: false,
        error: null,
      },
    });
  };

  closeUserEditDialog = () => {
    if (this.state.userEditDialog?.busy) return;
    this.setState({ userEditDialog: null });
  };

  submitUserEdit = async () => {
    const conf = this.state.userEditDialog;
    if (!conf) return;
    const spec = this.USER_EDIT_FIELDS[conf.field];
    const tenantId = this.props.data?.instituteId;
    if (!tenantId) {
      this.setState({ userEditDialog: { ...conf, error: "Tenant id missing — cannot continue." } });
      return;
    }
    const value = (conf.value || "").trim();
    if (!spec.allowEmpty && !value) {
      this.setState({ userEditDialog: { ...conf, error: `${spec.label} cannot be empty.` } });
      return;
    }
    if (spec.isEmail && value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
      this.setState({ userEditDialog: { ...conf, error: `${spec.label} must be a valid email address.` } });
      return;
    }
    // Send ONLY this one field — partial update, others untouched.
    const fields = { [spec.apiKey]: value };

    this.setState({ userEditDialog: { ...conf, busy: true, error: null } });
    try {
      await updateTenantUser(tenantId, conf.userId, fields);
      alert(`Updated ${spec.label.toLowerCase()} for ${conf.displayName}. The user list will refresh.`);
      this.setState({ userEditDialog: null });
      if (typeof this.props.getTenantUsers === "function") {
        this.props.getTenantUsers(tenantId);
      }
    } catch (err) {
      const statusCode = err?.response?.status;
      const body = err?.response?.data;
      let msg;
      if (statusCode === 404) {
        msg = "User not found in Zitadel.";
      } else if (statusCode === 403) {
        msg = "Not authorized to edit this user.";
      } else if (statusCode === 409) {
        msg = "That email is already in use by another user.";
      } else {
        msg = body?.message || body?.error || err?.message || "Update failed.";
      }
      this.setState({ userEditDialog: { ...conf, busy: false, error: msg } });
    }
  };

  // Tiny inline edit affordance rendered next to a Name/Email/Phone value.
  renderFieldEditButton(user, field) {
    if ((user.userType || user.user_type) === "machine") return null;
    const spec = this.USER_EDIT_FIELDS[field];
    return (
      <Tooltip title={`Edit ${spec.label.toLowerCase()}`}>
        <IconButton
          size="small"
          sx={{
            ml: 0.5,
            padding: "2px",
            color: "rgba(0,0,0,0.35)",
            transition: "background-color 120ms, color 120ms",
            "&:hover": { backgroundColor: "rgba(25,118,210,0.12)", color: "primary.main" },
          }}
          onClick={() => this.openUserEditField(user, field)}
        >
          <EditIcon sx={{ fontSize: 15 }} />
        </IconButton>
      </Tooltip>
    );
  }

  // ---- Business-name rename (support + platform admin) ----
  openOrgNameDialog = () => {
    const d = this.props.data || {};
    this.setState({ orgNameDialog: { value: d.name || d.tenantName || "", reason: "", busy: false, error: null } });
  }
  closeOrgNameDialog = () => this.setState({ orgNameDialog: null });
  submitOrgName = async () => {
    const conf = this.state.orgNameDialog;
    if (!conf || conf.busy) return;
    const orgId = this.props.data?.instituteId || this.props.data?.id;
    const name = (conf.value || "").trim();
    if (!orgId) { this.setState({ orgNameDialog: { ...conf, error: "Org id missing — cannot continue." } }); return; }
    if (name.length < 2) { this.setState({ orgNameDialog: { ...conf, error: "Business name must be at least 2 characters." } }); return; }
    if (name.length > 100) { this.setState({ orgNameDialog: { ...conf, error: "Business name must be at most 100 characters." } }); return; }
    this.setState({ orgNameDialog: { ...conf, busy: true, error: null } });
    try {
      const res = await updateOrgName(orgId, name, (conf.reason || "").trim());
      const finalName = res.org_name || res.orgName || name;
      if (typeof this.props.onOrgRenamed === "function") this.props.onOrgRenamed(orgId, finalName);
      this.setState({ orgNameDialog: null });
      alert(`Business name updated to "${finalName}". The customer sees it after their next sign-in.`);
    } catch (err) {
      const statusCode = err?.response?.status;
      const body = err?.response?.data;
      let msg;
      if (statusCode === 403 || statusCode === 401) msg = "Platform admin or support role required.";
      else if (statusCode === 404) msg = "Organization not found in Zitadel.";
      else msg = body?.message || body?.error || err?.message || "Rename failed.";
      this.setState({ orgNameDialog: { ...conf, busy: false, error: msg } });
    }
  }
  renderOrgNameDialog() {
    const conf = this.state.orgNameDialog;
    if (!conf) return null;
    return (
      <Dialog open={true} onClose={this.closeOrgNameDialog} maxWidth="xs" fullWidth>
        <DialogTitle>Edit business name</DialogTitle>
        <DialogContent style={{ paddingTop: 8 }}>
          <TextField
            label="Business name"
            fullWidth
            autoFocus
            margin="dense"
            value={conf.value}
            onChange={(e) => this.setState({ orgNameDialog: { ...this.state.orgNameDialog, value: e.target.value } })}
            disabled={conf.busy}
            helperText="Changes the organization name in Zitadel and in the admin list. Customers see it after their next sign-in."
            onKeyDown={(e) => { if (e.key === "Enter" && !conf.busy) this.submitOrgName(); }}
          />
          <TextField
            label="Reason (optional)"
            fullWidth
            margin="dense"
            value={conf.reason}
            onChange={(e) => this.setState({ orgNameDialog: { ...this.state.orgNameDialog, reason: e.target.value } })}
            disabled={conf.busy}
            placeholder="e.g. customer email 2026-09-07"
            helperText="Recorded in the audit log."
          />
          {conf.error && <p style={{ color: "red", fontSize: 13, marginTop: 8 }}>{conf.error}</p>}
        </DialogContent>
        <DialogActions>
          <Button onClick={this.closeOrgNameDialog} disabled={conf.busy}>Cancel</Button>
          <Button variant="contained" onClick={this.submitOrgName} disabled={conf.busy}>
            {conf.busy ? "Saving…" : "Save"}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  renderUserEditDialog() {
    const conf = this.state.userEditDialog;
    if (!conf) return null;
    const spec = this.USER_EDIT_FIELDS[conf.field];
    return (
      <Dialog open={true} onClose={this.closeUserEditDialog} maxWidth="xs" fullWidth>
        <DialogTitle>Edit {spec.label.toLowerCase()}</DialogTitle>
        <DialogContent style={{ paddingTop: 8 }}>
          <p style={{ margin: "0 0 8px", color: "rgba(0,0,0,0.6)", fontSize: 13 }}>
            {conf.displayName}
          </p>
          <TextField
            label={spec.label}
            type={spec.type || "text"}
            fullWidth
            autoFocus
            margin="dense"
            value={conf.value}
            onChange={(e) =>
              this.setState({ userEditDialog: { ...this.state.userEditDialog, value: e.target.value } })
            }
            disabled={conf.busy}
            placeholder={spec.placeholder}
            helperText={spec.helper}
            onKeyDown={(e) => { if (e.key === "Enter" && !conf.busy) this.submitUserEdit(); }}
          />
          {conf.error && (
            <p style={{ color: "red", fontSize: 13, marginTop: 8 }}>{conf.error}</p>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={this.closeUserEditDialog} disabled={conf.busy}>Cancel</Button>
          <Button variant="contained" onClick={this.submitUserEdit} disabled={conf.busy}>
            {conf.busy ? "Saving…" : "Save"}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  toggleUsernameCol = () => {
    this.setState(({ showUsernameCol }) => {
      const next = !showUsernameCol;
      try {
        window.localStorage.setItem(USERS_SHOW_USERNAME_KEY, next ? "1" : "0");
      } catch {
        // Private mode / storage disabled — toggle still works for this session.
      }
      return { showUsernameCol: next };
    });
  };

  renderUsersTab() {
    const { tenantUsersRes } = this.props;
    const { showUsernameCol, usersColMenuAnchor } = this.state;
    const isLoading = !tenantUsersRes;
    const users = tenantUsersRes?.success
      ? tenantUsersRes.data?.users || []
      : [];
    const error =
      tenantUsersRes && !tenantUsersRes.success
        ? tenantUsersRes.error || "Failed to load users"
        : null;

    if (isLoading) {
      return (
        <div style={{ display: "flex", justifyContent: "center", padding: 32 }}>
          <CircularProgress />
        </div>
      );
    }

    if (error) {
      return <p style={{ color: "red", padding: 16 }}>{error}</p>;
    }

    if (users.length === 0) {
      return (
        <p style={{ color: "rgba(0,0,0,0.54)", padding: 16 }}>
          No users found in this organization.
        </p>
      );
    }

    return (
      <div>
        <Box sx={{ display: "flex", justifyContent: "flex-end", pr: 1 }}>
          <Tooltip title="Column settings">
            <IconButton
              size="small"
              onClick={(e) => this.setState({ usersColMenuAnchor: e.currentTarget })}
            >
              <Settings fontSize="small" />
            </IconButton>
          </Tooltip>
          <Menu
            anchorEl={usersColMenuAnchor}
            open={!!usersColMenuAnchor}
            onClose={() => this.setState({ usersColMenuAnchor: null })}
          >
            <MenuItem dense onClick={this.toggleUsernameCol}>
              <Checkbox
                size="small"
                checked={showUsernameCol}
                sx={{ p: 0, mr: 1 }}
              />
              Show Username column
            </MenuItem>
          </Menu>
        </Box>
        <div style={{ overflowX: "auto" }}>
        <table
          style={{ width: "100%", borderCollapse: "collapse", fontSize: 14 }}
        >
          <thead>
            <tr
              style={{ borderBottom: "2px solid #e0e0e0", textAlign: "left" }}
            >
              <th style={{ padding: "8px 12px" }}>Full Name</th>
              {showUsernameCol && (
                <th style={{ padding: "8px 12px" }}>Username</th>
              )}
              <th style={{ padding: "8px 12px" }}>Email</th>
              <th style={{ padding: "8px 12px" }}>Phone</th>
              <th style={{ padding: "8px 12px" }}>Active</th>
              <th style={{ padding: "8px 12px" }}>Owner</th>
              <th style={{ padding: "8px 12px" }}>Created</th>
              <th style={{ padding: "8px 12px" }}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {users.map((u) => (
              <tr key={u.id} style={{ borderBottom: "1px solid #f0f0f0" }}>
                <td style={{ padding: "8px 12px", whiteSpace: "nowrap" }}>
                  {u.fullName || u.full_name || "-"}
                  {(u.userType || u.user_type) === "machine" ? (
                    <Chip
                      label="SA"
                      size="small"
                      variant="outlined"
                      sx={{ ml: 1, fontSize: 10, height: 18 }}
                    />
                  ) : (
                    this.renderFieldEditButton(u, "fullName")
                  )}
                </td>
                {showUsernameCol && (
                  <td style={{ padding: "8px 12px", whiteSpace: "nowrap" }}>
                    {u.username || u.preferred_login_name || "-"}
                    {this.renderFieldEditButton(u, "username")}
                  </td>
                )}
                <td style={{ padding: "8px 12px", whiteSpace: "nowrap" }}>
                  {u.email || "-"}
                  {this.renderFieldEditButton(u, "email")}
                </td>
                <td style={{ padding: "8px 12px", whiteSpace: "nowrap" }}>
                  {u.phone || u.phone_number || "-"}
                  {this.renderFieldEditButton(u, "phone")}
                </td>
                <td style={{ padding: "8px 12px" }}>
                  {u.isActive || u.is_active ? (
                    <CheckCircle style={{ color: "green", fontSize: 18 }} />
                  ) : (
                    <Cancel style={{ color: "red", fontSize: 18 }} />
                  )}
                </td>
                <td style={{ padding: "8px 12px" }}>
                  {u.isTenantOwner || u.is_tenant_owner ? (
                    <Chip
                      label="Owner"
                      size="small"
                      color="primary"
                      variant="outlined"
                    />
                  ) : (
                    "-"
                  )}
                </td>
                <td style={{ padding: "8px 12px" }}>
                  {u.createdAt || u.created_at
                    ? dateFormat(new Date(u.createdAt || u.created_at))
                    : "-"}
                </td>
                <td style={{ padding: "8px 12px", minWidth: 200 }}>
                  {(u.userType || u.user_type) !== "machine" && (
                    // Layout (left → right):
                    //   [impersonate]   <large gap>   [4 actions, 2-col grid]
                    //
                    // Impersonate is the primary muscle-memory action so it
                    // anchors the left. The secondary actions (welcome email,
                    // code login, sessions, activate/deactivate) sit in a
                    // 2-column grid on the right with a wide gap between them
                    // and impersonate so the primary stays hard to mis-click.
                    //
                    // OTP-only cutover: the verify-email/invite action is
                    // GONE — onboarding creates email+phone VERIFIED
                    // (LOGIN_OTP_ONLY_VERIFIED_EMAIL) and auto-registers the
                    // OTP methods. Welcome email is the one account email
                    // support can still send (getting-started copy only — no
                    // credentials). Codes are minted only by the user's own
                    // login.
                    <Box sx={{ display: "inline-flex", alignItems: "center", gap: "28px" }}>
                      {(u.isActive || u.is_active) ? (
                        <Tooltip title="Login as this user">
                          <IconButton
                            size="small"
                            color="primary"
                            onClick={() =>
                              this.props.impersonateUser &&
                              this.props.impersonateUser(
                                u.id,
                                this.props.data?.instituteId,
                                u.fullName || u.full_name || u.email,
                                this.props.data?.name,
                              )
                            }
                          >
                            <Login fontSize="small" />
                          </IconButton>
                        </Tooltip>
                      ) : (
                        // Placeholder reserves the impersonate slot so the
                        // email-icon stack stays at the same x-offset for
                        // every row, regardless of user state.
                        <Box sx={{ width: 30 }} />
                      )}
                      <Box sx={{ display: "inline-grid", gridTemplateColumns: "repeat(2, auto)", gap: "4px 8px", justifyItems: "center" }}>
                        {/* MANDATE v2 (OTP-only login): invite/verify-email,
                            password-reset and passkey-setup actions removed —
                            none exists in the code-only world (onboarding
                            creates verified contacts). "Send Welcome Email"
                            replaced the retired reset-password slot: it emails
                            the getting-started welcome (no credential/link in
                            it). "Enable code login" remains for backfilling
                            pre-cutover users: it registers the zitadel OTP
                            auth methods (email/SMS). NOTE: there is
                            deliberately no "send login OTP" support action —
                            codes are session challenges born in the USER'S
                            OWN login attempt; support cannot mint one. */}
                        <Tooltip title={`Send welcome email to ${u.email || "user"}`}>
                          <span>
                            <IconButton
                              size="small"
                              sx={{
                                color: "rgba(0,0,0,0.54)",
                                padding: "4px",
                                transition: "background-color 120ms, color 120ms",
                                "&:hover": {
                                  backgroundColor: "rgba(25,118,210,0.12)",
                                  color: "primary.main",
                                },
                              }}
                              disabled={!u.email}
                              onClick={() => this.openWelcomeEmailConfirm(u)}
                            >
                              <MailOutline fontSize="small" />
                            </IconButton>
                          </span>
                        </Tooltip>
                        <Tooltip title={`Enable code login for ${u.email || "user"}`}>
                          <span>
                            <IconButton
                              size="small"
                              sx={{
                                color: "rgba(0,0,0,0.54)",
                                padding: "4px",
                                transition: "background-color 120ms, color 120ms",
                                "&:hover": {
                                  backgroundColor: "rgba(156,39,176,0.12)",
                                  color: "secondary.main",
                                },
                              }}
                              onClick={() => this.ensureCodeLogin(u)}
                            >
                              <Fingerprint fontSize="small" />
                            </IconButton>
                          </span>
                        </Tooltip>
                        {/* Zitadel sessions (list + terminate) — server-side
                            half of single-account: kill the IdP sessions the
                            browser guard can't reach. */}
                        <Tooltip title={`Sessions of ${u.email || "user"}`}>
                          <span>
                            <IconButton
                              size="small"
                              sx={{
                                color: "rgba(0,0,0,0.54)",
                                padding: "4px",
                                transition: "background-color 120ms, color 120ms",
                                "&:hover": {
                                  backgroundColor: "rgba(2,136,209,0.12)",
                                  color: "info.main",
                                },
                              }}
                              onClick={() => this.openUserSessions(u)}
                            >
                              <Settings fontSize="small" />
                            </IconButton>
                          </span>
                        </Tooltip>
                        {/* IAM-layer toggle (zitadel UserState). Distinct from
                            the tenant-level account_status flip on the Account
                            tab — this one only controls login on/off, not
                            billing. See docs/ADR_TENANT_STATUS_AND_TIER.md. */}
                        {(() => {
                          const isInactive = (u.user_state || u.userState || "").toUpperCase() === "USER_STATE_INACTIVE";
                          // Deactivate cuts a customer's login — platform admins
                          // only. Support keeps activate (backend mirrors this via
                          // the support:users:deactivate action).
                          if (!isInactive && !isPlatformAdminRole(this.props.userRole)) return null;
                          const label = isInactive
                            ? `Activate ${u.email || "user"}`
                            : `Deactivate ${u.email || "user"}`;
                          const hoverBg = isInactive ? "rgba(46,125,50,0.14)" : "rgba(211,47,47,0.14)";
                          const hoverColor = isInactive ? "success.main" : "error.main";
                          return (
                            <Tooltip title={label}>
                              <span>
                                <IconButton
                                  size="small"
                                  sx={{
                                    color: "rgba(0,0,0,0.54)",
                                    padding: "4px",
                                    transition: "background-color 120ms, color 120ms",
                                    "&:hover": { backgroundColor: hoverBg, color: hoverColor },
                                  }}
                                  onClick={() => this.openUserStateConfirm(isInactive ? "activate" : "deactivate", u)}
                                >
                                  {isInactive ? <PersonAddAlt1 fontSize="small" /> : <PersonOff fontSize="small" />}
                                </IconButton>
                              </span>
                            </Tooltip>
                          );
                        })()}
                      </Box>
                    </Box>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        </div>
        {tenantUsersRes?.data?.pagination && (
          <p
            style={{
              color: "rgba(0,0,0,0.54)",
              fontSize: 12,
              padding: "8px 12px",
            }}
          >
            Total:{" "}
            {tenantUsersRes.data.pagination.total_count ||
              tenantUsersRes.data.pagination.totalCount ||
              users.length}{" "}
            users
          </p>
        )}
        {this.renderUserStateConfirm()}
        {this.renderWelcomeEmailConfirm()}
        {this.renderUserSessionsDialog()}
        {this.renderUserEditDialog()}
        {this.renderOrgNameDialog()}
      </div>
    );
  }

  // Zitadel sessions dialog: every IdP session the user still holds, with
  // per-session Terminate + Terminate-all. Complements the browser-side
  // SessionIdentityGuard (latest-login-wins): the guard cleans up tabs, this
  // kills the sessions zitadel itself remembers.
  // Confirm dialog for the per-user "Send Welcome Email" action — same
  // scaffolding as the retired invite/reset account-email confirm.
  renderWelcomeEmailConfirm() {
    const conf = this.state.welcomeEmailConfirm;
    if (!conf) return null;
    return (
      <Dialog
        open
        onClose={this.closeWelcomeEmailConfirm}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>Send welcome email?</DialogTitle>
        <DialogContent>
          <Typography variant="body2" sx={{ mb: 1 }}>
            This will email the getting-started welcome to the user. It
            contains no credentials or login links — they sign in with login
            codes (email/SMS). A 5-minute cooldown applies between sends.
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Recipient: <strong>{conf.displayName}</strong>
            {conf.email && conf.email !== conf.displayName ? (
              <>{" "}&lt;{conf.email}&gt;</>
            ) : null}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={this.closeWelcomeEmailConfirm}
            disabled={conf.busy}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={this.submitWelcomeEmail}
            disabled={conf.busy}
          >
            {conf.busy ? "Sending…" : "Send welcome email"}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  renderUserSessionsDialog() {
    const us = this.state.userSessions;
    if (!us) return null;
    const busy = !!us.busyId || us.terminatingAll;
    const fmtDate = (raw) => {
      if (!raw) return "--";
      const d = new Date(raw);
      return isNaN(d.getTime()) ? "--" : dateFormat(d);
    };
    // Zitadel keeps expired session records (incl. abandoned login attempts);
    // they're listing noise, not exposure — hide them unless asked.
    const activeSessions = us.sessions.filter(this.isSessionActive);
    const expiredCount = us.sessions.length - activeSessions.length;
    const visibleSessions = us.showExpired ? us.sessions : activeSessions;
    return (
      <Dialog open onClose={this.closeUserSessions} maxWidth="md" fullWidth>
        <DialogTitle>Sessions — {us.displayName}</DialogTitle>
        <DialogContent>
          {!us.loading && !us.error && expiredCount > 0 && (
            <FormControlLabel
              sx={{ mb: 1 }}
              control={
                <Checkbox
                  size="small"
                  checked={us.showExpired}
                  disabled={busy}
                  onChange={(e) => this.setState({ userSessions: { ...us, showExpired: e.target.checked } })}
                />
              }
              label={<Typography variant="caption">Show {expiredCount} expired session(s)</Typography>}
            />
          )}
          {us.loading ? (
            <Box sx={{ display: "flex", justifyContent: "center", p: 3 }}>
              <CircularProgress size={28} />
            </Box>
          ) : us.error ? (
            <Alert severity="error">{us.error}</Alert>
          ) : !visibleSessions.length ? (
            <Typography variant="body2" color="text.secondary" sx={{ p: 1 }}>
              No active sessions — the user is signed out everywhere.
            </Typography>
          ) : (
            visibleSessions.map((sess) => (
              <Box
                key={sess.sessionId}
                sx={{
                  display: "flex", alignItems: "center", gap: 2, py: 1,
                  borderBottom: "1px solid #eee",
                }}
              >
                <Box sx={{ flex: 1, minWidth: 0, opacity: this.isSessionActive(sess) ? 1 : 0.5 }}>
                  {/* Full UA wraps (no truncation) so the device is
                      identifiable; empty comma-segments from the backend
                      ("Chrome, 150, , Apple, , Blink") are collapsed. */}
                  <Typography variant="body2">
                    {(sess.userAgent || "Unknown browser").replace(/(,\s*)+/g, ", ").replace(/^[,\s]+|[,\s]+$/g, "")}
                    {sess.ip ? ` · ${sess.ip}` : ""}
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    Started {fmtDate(sess.creationDate)}
                    {sess.changeDate ? ` · last active ${fmtDate(sess.changeDate)}` : ""}
                    {sess.expirationDate ? ` · ${this.isSessionActive(sess) ? "expires" : "expired"} ${fmtDate(sess.expirationDate)}` : ""}
                  </Typography>
                </Box>
                {this.isSessionActive(sess) ? (
                  <Button
                    size="small" color="error" variant="outlined"
                    disabled={busy}
                    onClick={() => this.terminateSession(sess.sessionId)}
                  >
                    {us.busyId === sess.sessionId ? <CircularProgress size={16} /> : "Terminate"}
                  </Button>
                ) : (
                  <Typography variant="caption" color="text.secondary">Expired</Typography>
                )}
              </Box>
            ))
          )}
        </DialogContent>
        <DialogActions>
          {!us.loading && activeSessions.length > 1 && (
            <Button color="error" disabled={busy} onClick={this.terminateAllSessions} sx={{ mr: "auto" }}>
              {us.terminatingAll ? "Terminating…" : "Terminate all"}
            </Button>
          )}
          <Button onClick={this.refreshUserSessions} disabled={us.loading || busy}>
            Refresh
          </Button>
          <Button onClick={this.closeUserSessions} disabled={busy}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  renderSmsConfigTab() {
    let { data, tenantSmsConfig } = this.props;
    let { instituteId } = data;

    // Extract sender IDs, message types, and DLT ID from API response
    // Response shape: {success, data: {senderIds, messageTypes, dltPrincipalEntityId}}
    const smsConfigResp = tenantSmsConfig?.data || tenantSmsConfig || {};
    const smsConfig = smsConfigResp.data || smsConfigResp;
    const apiSenderIds = smsConfig.senderIds || smsConfig.sender_ids || [];
    // Numeric-header senders carry promotional traffic — drives the
    // conditional Industry Category field below; no category picker.
    const tplSenderIsPromo = this.isPromoSender();
    const apiMessageTypes =
      smsConfig.messageTypes || smsConfig.message_types || [];
    const dltPrincipalEntityId =
      smsConfig.dltPrincipalEntityId ||
      smsConfig.dlt_principal_entity_id ||
      data.dltPrincipalEntityId;
    // Header delete is limited to platform-tier roles (platform_admin /
    // admin / admin_agent / support_agent) — same gate as the panel itself,
    // kept explicit as defence-in-depth.
    const canDeleteHeader = isAdminPanelRole(this.props.userRole);
    // Per-tenant TM-A,TM-D override (TLV 0x1402). Empty/undefined when no
    // override is set — resolver falls back to env COMBIRD_DLT_TM_ID +
    // operators.dlt_tm_id at submit time.

    return (
      <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
          <VerifiedUser />
          <div>
            <p style={{ color: "rgba(0, 0, 0, 0.54)" }}>Institute ID</p>
            <p style={{ fontSize: 16 }}>{instituteId}</p>
          </div>
        </div>

        {/* Sender IDs (Headers) */}
        <div style={{ display: "flex", alignItems: "flex-start", gap: 16 }}>
          <AssignmentInd style={{ marginTop: 4 }} />
          <div style={{ flex: 1 }}>
            <p style={{ color: "rgba(0, 0, 0, 0.54)", marginBottom: 4 }}>
              Sender IDs / Headers
            </p>
            {apiSenderIds.length > 0 ? (
              apiSenderIds.map((sid) => (
                <div
                  key={sid.id || sid.senderId}
                  style={{
                    display: "flex",
                    gap: 12,
                    alignItems: "center",
                    marginBottom: 4,
                  }}
                >
                  <span
                    style={{
                      fontSize: 16,
                      fontWeight: sid.isDefault ? 600 : 400,
                    }}
                  >
                    {sid.senderId}
                  </span>
                  {sid.isDefault ? (
                    <Chip label="default" size="small" color="primary" />
                  ) : (
                    <Chip
                      label="set default"
                      size="small"
                      variant="outlined"
                      clickable
                      onClick={() =>
                        this.handleSetDefaultSenderId(sid.senderId)
                      }
                    />
                  )}
                  <Tooltip title="Edit downstream TMD">
                    <IconButton
                      size="small"
                      onClick={() => this.openEditSenderIdTmd(sid)}
                    >
                      <EditIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                  {canDeleteHeader && (
                    <Tooltip
                      title={
                        sid.isDefault
                          ? "Default header cannot be deleted — set another header as default first"
                          : "Delete header"
                      }
                    >
                      <span>
                        <IconButton
                          size="small"
                          disabled={sid.isDefault}
                          onClick={() => this.openDeleteHeader(sid)}
                        >
                          <DeleteIcon fontSize="small" />
                        </IconButton>
                      </span>
                    </Tooltip>
                  )}
                  {(() => {
                    const mode = sid.dltTmdMode || sid.dlt_tmd_mode || "";
                    const tmd = sid.dltTmdId || sid.dlt_tmd_id || "";
                    if (mode === "inherit") {
                      return (
                        <span style={{fontSize: 12, color: "#999"}}>
                          TMD: inherit (route operator)
                        </span>
                      );
                    }
                    // explicit — and legacy rows (no mode) that carry a TMD
                    if (mode === "explicit" || (!mode && tmd)) {
                      return (
                        <span style={{fontSize: 12, color: "#999"}}>
                          TMD: {tmd}
                        </span>
                      );
                    }
                    // direct — chain ends at ComBird, NO downstream TMD is
                    // appended to TLV 0x1402. Rendered explicitly: operators
                    // that scrub the full PE-TM chain reject these, and a
                    // blank cell made that state indistinguishable from
                    // "nobody has configured this header yet".
                    return (
                      <Tooltip title="No downstream telemarketer is appended to the DLT chain (0x1402 = PEID,ComBird). Operators that require their own TM ID will reject these messages — switch to 'inherit' if traffic routes via such an operator.">
                        <span style={{fontSize: 12, color: "#c77700"}}>
                          TMD: direct (chain ends at ComBird)
                        </span>
                      </Tooltip>
                    );
                  })()}
                </div>
              ))
            ) : (
              <p style={{ fontSize: 14, color: "#999" }}>
                No sender IDs configured
              </p>
            )}
          </div>
          <Button size="small" onClick={this.openAddSenderId}>
            Add More Header
          </Button>
        </div>

        {/* Message Types */}
        <div style={{ display: "flex", alignItems: "flex-start", gap: 16 }}>
          <Sms style={{ marginTop: 4 }} />
          <div style={{ flex: 1 }}>
            <p style={{ color: "rgba(0, 0, 0, 0.54)", marginBottom: 4 }}>
              Message Types
            </p>
            {apiMessageTypes.length > 0 ? (
              apiMessageTypes.map((mt) => (
                <div
                  key={mt.id || mt.messageType}
                  style={{
                    display: "flex",
                    gap: 12,
                    alignItems: "center",
                    marginBottom: 4,
                  }}
                >
                  <span
                    style={{
                      fontSize: 16,
                      fontWeight: mt.isDefault ? 600 : 400,
                    }}
                  >
                    {mt.messageType}
                  </span>
                  {mt.isDefault ? (
                    <Chip label="default" size="small" color="primary" />
                  ) : (
                    <Chip
                      label="set default"
                      size="small"
                      variant="outlined"
                      clickable
                      onClick={() =>
                        this.handleSetDefaultSmsType(mt.messageType)
                      }
                    />
                  )}
                </div>
              ))
            ) : (
              <p style={{ fontSize: 14, color: "#999" }}>
                No message types configured
              </p>
            )}
          </div>
          <Button size="small" onClick={this.openAddSMSType}>
            Add More SMS Types
          </Button>
        </div>

                {/* DLT ID */}
        <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
          <AssignmentInd />
          <div>
            <p style={{ color: "rgba(0, 0, 0, 0.54)" }}>DLT ID</p>
            <p style={{ fontSize: 16 }}>{dltPrincipalEntityId || "NA"}</p>
          </div>
          <Button size="small" onClick={this.toggleEditDLTId}>
            Edit DLT ID
          </Button>
          {/* Admin + support (ClearDltId allows both). Lets ops reset an org to
              "no PE ID" to re-test the self-signup first-run. */}
          {dltPrincipalEntityId &&
          (isPlatformAdminRole(this.props.userRole) || isSupportTierRole(this.props.userRole)) ? (
            <Button size="small" color="error" onClick={this.toggleClearDLTId}>
              Clear DLT ID
            </Button>
          ) : null}
        </div>

        {/* Templates */}
        <div style={{ display: "flex", alignItems: "flex-start", gap: 16 }}>
          <Description style={{ marginTop: 4 }} />
          <div style={{ flex: 1 }}>
            <p style={{ color: "rgba(0, 0, 0, 0.54)", marginBottom: 8 }}>
              Templates
            </p>
            {(() => {
              const templates =
                this.props.adminTemplates?.templates ||
                this.props.adminTemplates?.data?.templates ||
                this.props.adminTemplates?.data?.list ||
                [];
              if (templates.length === 0) {
                return (
                  <p style={{ fontSize: 14, color: "#999" }}>
                    No templates configured
                  </p>
                );
              }
              return (
                <table
                  style={{
                    width: "100%",
                    fontSize: 13,
                    borderCollapse: "collapse",
                  }}
                >
                  <thead>
                    <tr
                      style={{
                        borderBottom: "1px solid #eee",
                        textAlign: "left",
                      }}
                    >
                      <th
                        style={{
                          padding: "4px 8px",
                          color: "rgba(0,0,0,0.54)",
                          fontWeight: 500,
                        }}
                      >
                        Header
                      </th>
                      <th
                        style={{
                          padding: "4px 8px",
                          color: "rgba(0,0,0,0.54)",
                          fontWeight: 500,
                        }}
                      >
                        Name
                      </th>
                      <th
                        style={{
                          padding: "4px 8px",
                          color: "rgba(0,0,0,0.54)",
                          fontWeight: 500,
                        }}
                      >
                        Template Text
                      </th>
                      <th
                        style={{
                          padding: "4px 8px",
                          color: "rgba(0,0,0,0.54)",
                          fontWeight: 500,
                        }}
                      >
                        DLT ID
                      </th>
                      <th
                        style={{
                          padding: "4px 8px",
                          color: "rgba(0,0,0,0.54)",
                          fontWeight: 500,
                          width: 80,
                        }}
                      >
                        Actions
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {templates.map((tpl) => (
                      <tr
                        key={tpl.id}
                        style={{ borderBottom: "1px solid #f5f5f5" }}
                      >
                        <td style={{ padding: "6px 8px" }}>
                          {tpl.senderId ||
                            tpl.sender_id ||
                            tpl.senderIdRef ||
                            tpl.sender_id_ref ||
                            "--"}
                        </td>
                        <td style={{ padding: "6px 8px" }}>
                          {tpl.templateName || tpl.template_name || "--"}
                        </td>
                        <td
                          style={{
                            padding: "6px 8px",
                            maxWidth: 220,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        >
                          <Tooltip
                            title={tpl.templateText || tpl.template_text || ""}
                          >
                            <span>
                              {tpl.templateText || tpl.template_text || "--"}
                            </span>
                          </Tooltip>
                        </td>
                        <td style={{ padding: "6px 8px", fontSize: 12 }}>
                          {tpl.dltTemplateId || tpl.dlt_template_id || "--"}
                        </td>
                        <td style={{ padding: "6px 8px" }}>
                          <IconButton
                            size="small"
                            onClick={() => this.openEditTemplate(tpl)}
                          >
                            <EditIcon fontSize="small" />
                          </IconButton>
                          <IconButton
                            size="small"
                            color="error"
                            onClick={() => this.openDeleteTemplate(tpl)}
                          >
                            <DeleteIcon fontSize="small" />
                          </IconButton>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              );
            })()}
          </div>
          <Button size="small" onClick={this.openAddTemplate}>
            Add Template
          </Button>
        </div>

        {/* Template Form Dialog */}
        {this.state.showTemplateForm && (
          <Dialog open onClose={this.closeTemplateForm} maxWidth="sm" fullWidth>
            <DialogTitle>
              {this.state.editingTemplate ? "Edit Template" : "Add Template"}
            </DialogTitle>
            <DialogContent
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 2,
                pt: "8px !important",
              }}
            >
              <FormControl fullWidth size="small">
                <InputLabel>Sender ID (Header)</InputLabel>
                <Select
                  value={this.state.tplSenderId}
                  label="Sender ID (Header)"
                  onChange={(e) =>
                    this.setState({ tplSenderId: e.target.value })
                  }
                >
                  {apiSenderIds.map((sid) => (
                    <MenuItem key={sid.id || sid.senderId} value={sid.id}>
                      {sid.senderId}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <TextField
                label="Template Name"
                size="small"
                fullWidth
                value={this.state.tplName}
                onChange={(e) => this.setState({ tplName: e.target.value })}
              />
              <TextField
                label="DLT Template ID"
                size="small"
                fullWidth
                value={this.state.tplDltId}
                onChange={(e) => this.setState({ tplDltId: e.target.value })}
                disabled={!!this.state.editingTemplate}
              />
              <TextField
                label="Template Text (exactly as per DLT)"
                size="small"
                fullWidth
                multiline
                rows={3}
                value={this.state.tplText}
                onChange={(e) => this.setState({ tplText: e.target.value })}
              />
              {/* No category field: the compliance class follows the Sender
                  ID's header type — numeric-header senders are promotional
                  traffic and get the Industry Category field below. */}
              {tplSenderIsPromo && (
                <TextField
                  label="Industry Category"
                  size="small"
                  fullWidth
                  value={this.state.tplIndustry || ""}
                  onChange={(e) =>
                    this.setState({ tplIndustry: e.target.value })
                  }
                  helperText="Required for Promotional templates since 14 Jul 2026 — the Industry Category registered against this template on the DLT portal (e.g. Education, Health, Banking)."
                />
              )}
              {/* Platform view — TMD is hidden from customers but always
                  editable here in the admin panel. */}
              <DltTmdField
                label="TMD override (rare)"
                value={this.state.tplTmdOverride}
                onChange={(v) => this.setState({ tplTmdOverride: v })}
                helperText="Only when THIS template's chain is approved via a different downstream than its header. Empty = use the header's TMD."
                textFieldProps={{ size: "small", fullWidth: true }}
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={this.closeTemplateForm}>Cancel</Button>
              <Button
                variant="contained"
                onClick={this.saveTemplate}
                disabled={this.state.tplSaving}
              >
                {this.state.tplSaving ? <CircularProgress size={20} /> : "Save"}
              </Button>
            </DialogActions>
          </Dialog>
        )}

        {/* Delete Template Confirmation */}
        {this.state.showDeleteTemplate && this.state.deleteTemplateTarget && (
          <Dialog open onClose={this.closeDeleteTemplate}>
            <DialogTitle>Delete Template?</DialogTitle>
            <DialogContent>
              <p style={{ margin: 0 }}>
                Delete template{" "}
                <b>
                  {this.state.deleteTemplateTarget.templateName ||
                    this.state.deleteTemplateTarget.template_name}
                </b>
                ? This action cannot be undone.
              </p>
            </DialogContent>
            <DialogActions>
              <Button onClick={this.closeDeleteTemplate}>Cancel</Button>
              <Button
                variant="contained"
                color="error"
                onClick={this.confirmDeleteTemplate}
              >
                Delete
              </Button>
            </DialogActions>
          </Dialog>
        )}

      </div>
    );
  }

  handleCreateWallets = () => {
    const { data } = this.props;
    const { createWalletTypes, createWalletCredits, createWalletRemarks } =
      this.state;
    const selectedTypes = Object.keys(createWalletTypes || {}).filter(
      (k) => createWalletTypes[k],
    );
    if (selectedTypes.length === 0) return;
    this.props.adminCreateWallets(
      data.instituteId,
      "sms",
      selectedTypes,
      parseInt(createWalletCredits) || 0,
      undefined,
      createWalletRemarks || undefined,
    );
    this.setState({
      showCreateWallet: false,
      createWalletTypes: {},
      createWalletCredits: "",
      createWalletRemarks: "",
    });
    setTimeout(() => {
      this.props.adminGetCustomerWallets(data.instituteId, "sms");
    }, 500);
  };

  handleCreateCustomWallet = () => {
    const { data } = this.props;
    const {
      packName,
      packRate,
      packCredits,
      packPriority,
      packChannel,
      packMessageType,
      packRemarks,
    } = this.state;
    if (
      !packName ||
      !packRate ||
      !packCredits ||
      !packPriority ||
      !packChannel ||
      !packMessageType
    )
      return;
    this.props.adminCreateCustomWallet(
      data.instituteId,
      packName,
      packRate,
      packCredits,
      "INR",
      parseInt(packPriority),
      packChannel,
      packMessageType,
      packRemarks || undefined,
    );
    this.setState({
      showAddPack: false,
      packName: "",
      packRate: "",
      packCredits: "",
      packPriority: "",
      packChannel: "sms",
      packMessageType: "",
      packRemarks: "",
    });
    setTimeout(() => {
      this.props.adminGetCustomerWallets(data.instituteId, "sms");
    }, 500);
  };

  handleBillingTopUp = () => {
    const { data } = this.props;
    const { topUpLagoId, topUpAmount, topUpRemarks } = this.state;
    if (!topUpLagoId || !topUpAmount) return;
    // Target the wallet by its lago_id (canonical billing id), not the name.
    this.props.adminTopUpWallet(
      data.instituteId,
      topUpLagoId,
      topUpAmount,
      topUpRemarks || undefined,
    );
    this.setState({
      showTopUp: false,
      topUpWallet: "",
      topUpLagoId: "",
      topUpAmount: "",
      topUpRemarks: "",
    });
    // Refresh wallets after a short delay
    setTimeout(() => {
      this.props.adminGetCustomerWallets(data.instituteId, "sms");
      this.props.adminGetCustomerTransactions(data.instituteId, "");
    }, 500);
  };

  handleVoidWalletCredits = () => {
    const { data } = this.props;
    const { voidWalletLagoId, voidCreditsAmount, voidRemarks } = this.state;
    if (!voidWalletLagoId || !voidCreditsAmount) return;
    this.props.adminVoidWalletCredits(
      data.instituteId,
      voidWalletLagoId,
      voidCreditsAmount,
      voidRemarks || undefined,
    );
    this.setState({
      showVoidCredits: false,
      voidWalletLagoId: "",
      voidWalletName: "",
      voidCreditsAmount: "",
      voidRemarks: "",
    });
    setTimeout(() => {
      this.props.adminGetCustomerWallets(data.instituteId, "sms");
      this.props.adminGetCustomerTransactions(data.instituteId, "");
    }, 500);
  };

  handleTerminateWallet = () => {
    const { data } = this.props;
    const { terminateWalletLagoId } = this.state;
    if (!terminateWalletLagoId) return;
    this.props.adminTerminateWallet(data.instituteId, terminateWalletLagoId);
    this.setState({
      showTerminateConfirm: false,
      terminateWalletLagoId: "",
      terminateWalletName: "",
      terminateConfirmText: "",
    });
    setTimeout(() => {
      this.props.adminGetCustomerWallets(data.instituteId, "sms");
    }, 500);
  };

  handleChangePlan = () => {
    const { data } = this.props;
    const { selectedPlanCode } = this.state;
    if (!selectedPlanCode) return;
    this.props.adminChangeSubscription(data.instituteId, selectedPlanCode);
    this.setState({ showChangePlan: false, selectedPlanCode: "" });
    setTimeout(() => {
      this.props.adminGetSubscription(data.instituteId);
    }, 500);
  };

  handleCreatePlan = () => {
    const {
      newPlanName,
      newPlanCode,
      newPlanInterval,
      newPlanAmount,
      newPlanCurrency,
      newPlanSmsRate,
    } = this.state;
    if (!newPlanName || !newPlanCode) return;
    this.props.adminCreatePlan({
      name: newPlanName,
      code: newPlanCode,
      interval: newPlanInterval || "yearly",
      amount_cents: String(Math.round((parseFloat(newPlanAmount) || 0) * 100)),
      currency: newPlanCurrency || "INR",
      sms_rate: newPlanSmsRate || undefined,
    });
    this.setState({
      showCreatePlan: false,
      newPlanName: "",
      newPlanCode: "",
      newPlanInterval: "yearly",
      newPlanAmount: "",
      newPlanCurrency: "INR",
      newPlanSmsRate: "",
    });
    setTimeout(() => this.props.adminListPlans(), 500);
  };

  handleUpdatePlan = () => {
    const {
      editPlanCode,
      editPlanName,
      editPlanInterval,
      editPlanAmount,
      editPlanCurrency,
      editPlanSmsRate,
    } = this.state;
    if (!editPlanCode) return;
    this.props.adminUpdatePlan(editPlanCode, {
      name: editPlanName,
      interval: editPlanInterval,
      amount_cents: String(Math.round((parseFloat(editPlanAmount) || 0) * 100)),
      currency: editPlanCurrency || "INR",
      sms_rate: editPlanSmsRate || undefined,
    });
    this.setState({ showEditPlan: false });
    setTimeout(() => this.props.adminListPlans(), 500);
  };

  handleDeletePlan = () => {
    const { deletePlanCode } = this.state;
    if (!deletePlanCode) return;
    this.props.adminDeletePlan(deletePlanCode);
    this.setState({
      showDeletePlan: false,
      deletePlanCode: "",
      deletePlanName: "",
    });
    setTimeout(() => this.props.adminListPlans(), 500);
  };

  handleEditWallet = () => {
    const { data } = this.props;
    const { editWalletLagoId, editWalletNewName, editWalletPriority } =
      this.state;
    if (!editWalletLagoId) return;
    const body = {};
    if (editWalletNewName) body.name = editWalletNewName;
    if (editWalletPriority) body.priority = parseInt(editWalletPriority);
    this.props.adminEditWallet(data.instituteId, editWalletLagoId, body);
    this.setState({ showEditWallet: false });
    setTimeout(
      () => this.props.adminGetCustomerWallets(data.instituteId, "sms"),
      500,
    );
  };

  renderBillingTab() {
    const { adminWallets, adminTransactions, adminPlans, adminSubscription } =
      this.props;
    const wallets = adminWallets?.wallets || [];
    const transactions = adminTransactions?.transactions || [];
    const plans = adminPlans?.plans || [];
    const subscription = adminSubscription?.subscription || null;
    const { showTopUp, showCreateWallet, showChangePlan } = this.state;

    const walletLabel = (name) => {
      if (!name) return "-";
      const parts = name.split("_");
      return parts.length >= 2
        ? parts
            .slice(1)
            .map((p) => p.charAt(0).toUpperCase() + p.slice(1))
            .join(" ")
        : name;
    };

    const typeOfWallet = (w) => {
      const parts = (w.walletName || "").split("_");
      return parts.length >= 2 ? parts.slice(1).join("_") : w.walletName;
    };
    const existingTypes = wallets.map(typeOfWallet);
    const allWalletTypes = ["transactional", "promotional", "otp"];
    const availableTypes = allWalletTypes.filter(
      (t) => !existingTypes.includes(t),
    );
    // Current priority per message type — an already-filled type shows its
    // P-value in the Standard dialog instead of being invisible. A standard
    // wallet is one-per-type (backend rejects a duplicate on the stable
    // code); a second wallet for the same type goes via Custom Pack.
    const priorityByType = {};
    wallets.forEach((w) => {
      const t = typeOfWallet(w);
      if (priorityByType[t] == null && w.priority != null) {
        priorityByType[t] = w.priority;
      }
    });

    const planRateDisplay = (plan) => {
      if (plan.smsRate) return `${Math.round(parseFloat(plan.smsRate) * 100)}p`;
      return null;
    };

    const totalBalanceCents = wallets
      .filter((w) => w.status === 1 || w.status === "WALLET_STATUS_ACTIVE")
      .reduce((sum, w) => sum + Number(w.balanceCents || 0), 0);

    const rateDisplay = (rateAmount) => {
      if (!rateAmount || rateAmount === "0") return null;
      const paise = Math.round(parseFloat(rateAmount) * 100);
      return `${paise}p/SMS`;
    };

    // Section header style (Lago-inspired)
    const sectionHeaderSx = {
      display: "flex",
      alignItems: "center",
      gap: 1.5,
      mb: 2,
    };
    const sectionIconSx = { color: "#555", fontSize: 20 };

    return (
      <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
        {/* \u2500\u2500 SUBSCRIPTION PLAN \u2014 compact, muted; Wallet Balances below
            carries the visual weight \u2500\u2500 */}
        <Paper variant="outlined" sx={{ p: 1.5, borderRadius: 2 }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
            <CreditCard sx={{ color: "#888", fontSize: 16 }} />
            <Typography variant="caption" fontWeight={600} color="text.secondary" sx={{ flex: 1, textTransform: "uppercase", letterSpacing: 0.4 }}>
              Subscription Plan
            </Typography>
            <Button
              size="small"
              variant={subscription ? "text" : "contained"}
              color="primary"
              sx={{ textTransform: "none", fontWeight: 500, py: 0 }}
              onClick={() =>
                this.setState({
                  showChangePlan: true,
                  selectedPlanCode: subscription?.planCode || "",
                })
              }
            >
              {subscription ? "Change Plan" : "Assign Plan"}
            </Button>
          </Box>
          {subscription ? (
            (() => {
              const matchedPlan = plans.find(
                (p) => p.code === subscription.planCode,
              );
              const rate = matchedPlan ? planRateDisplay(matchedPlan) : null;
              const fmtDate = (v) =>
                v && v !== "1970-01-01T00:00:00Z"
                  ? new Date(v).toLocaleDateString("en-IN", {
                      day: "numeric",
                      month: "short",
                      year: "numeric",
                    })
                  : "\u2014";
              return (
                <Box sx={{ display: "flex", gap: 1.5, flexWrap: "wrap" }}>
                  <Card variant="outlined" sx={{ minWidth: 180, borderRadius: 1.5, bgcolor: "#fafafa" }}>
                    <CardContent sx={{ p: 1.25, pb: "10px !important" }}>
                      <Typography variant="caption" color="text.secondary">
                        Current Plan
                      </Typography>
                      <Box sx={{ display: "flex", alignItems: "center", gap: 0.75, flexWrap: "wrap" }}>
                        <Typography variant="body2" fontWeight={700}>
                          {subscription.planName || subscription.planCode}
                        </Typography>
                        <Chip
                          label={subscription.status || "unknown"}
                          size="small"
                          color={subscription.status === "active" ? "success" : "default"}
                          variant="outlined"
                          sx={{ fontSize: 10, height: 18 }}
                        />
                        {matchedPlan && (
                          <Chip
                            label={matchedPlan.interval || "yearly"}
                            size="small"
                            variant="outlined"
                            sx={{ fontSize: 10, height: 18 }}
                          />
                        )}
                        {rate && (
                          <Typography variant="caption" fontWeight={600} color="text.secondary">
                            {rate}/SMS
                          </Typography>
                        )}
                      </Box>
                    </CardContent>
                  </Card>
                  <Card variant="outlined" sx={{ minWidth: 180, borderRadius: 1.5, bgcolor: "#fafafa" }}>
                    <CardContent sx={{ p: 1.25, pb: "10px !important" }}>
                      <Typography variant="caption" color="text.secondary">
                        Billing Period
                      </Typography>
                      <Typography variant="body2" fontWeight={600}>
                        {fmtDate(subscription.currentBillingPeriodStartedAt)}
                        {" \u2192 "}
                        {fmtDate(subscription.currentBillingPeriodEndingAt)}
                        <Typography component="span" variant="caption" color="text.secondary">
                          {"  \u00b7 started "}
                          {fmtDate(subscription.startedAt)}
                        </Typography>
                      </Typography>
                    </CardContent>
                  </Card>
                </Box>
              );
            })()
          ) : (
            <Typography variant="body2" color="text.secondary">
              No plan assigned
            </Typography>
          )}
        </Paper>
        {/* Change Plan Dialog */}
        {showChangePlan && (
          <Dialog
            open
            onClose={() => this.setState({ showChangePlan: false })}
            maxWidth="xs"
            fullWidth
          >
            <DialogTitle>
              {subscription ? "Change Plan" : "Assign Plan"}
            </DialogTitle>
            <DialogContent
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 16,
                paddingTop: 8,
              }}
            >
              <FormControl fullWidth size="small" sx={{ mt: 1 }}>
                <InputLabel>Plan</InputLabel>
                <Select
                  value={this.state.selectedPlanCode || ""}
                  label="Plan"
                  onChange={(e) =>
                    this.setState({ selectedPlanCode: e.target.value })
                  }
                >
                  {plans.map((p) => (
                    <MenuItem key={p.code} value={p.code}>
                      {p.name} {p.smsRate ? `(${planRateDisplay(p)}/SMS)` : ""}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              {subscription &&
                wallets.length > 0 &&
                this.state.selectedPlanCode &&
                this.state.selectedPlanCode !== subscription.planCode &&
                (() => {
                  const newPlan = plans.find(
                    (p) => p.code === this.state.selectedPlanCode,
                  );
                  const oldPlan = plans.find(
                    (p) => p.code === subscription.planCode,
                  );
                  const newRate = newPlan?.smsRate;
                  const oldRate = oldPlan?.smsRate;
                  const affectedWallets = wallets.filter(
                    (w) =>
                      w.rateAmount === oldRate &&
                      parseFloat(w.creditsBalance || 0) > 0,
                  );
                  if (
                    !newRate ||
                    !oldRate ||
                    newRate === oldRate ||
                    affectedWallets.length === 0
                  )
                    return null;
                  return (
                    <Box
                      sx={{
                        background: "#FFF3E0",
                        border: "1px solid #FFB74D",
                        borderRadius: 2,
                        p: 1.5,
                        fontSize: 13,
                      }}
                    >
                      <Typography
                        variant="body2"
                        fontWeight={600}
                        color="#E65100"
                      >
                        Wallet rate warning
                      </Typography>
                      <Typography
                        variant="body2"
                        color="#BF360C"
                        sx={{ mt: 0.5 }}
                      >
                        {affectedWallets.length} existing wallet
                        {affectedWallets.length > 1 ? "s" : ""} at{" "}
                        <b>
                          {oldRate
                            ? `${Math.round(parseFloat(oldRate) * 100)}p`
                            : "?"}
                          /SMS
                        </b>{" "}
                        will keep{" "}
                        {parseFloat(newRate) < parseFloat(oldRate)
                          ? "the old higher"
                          : "the old lower"}{" "}
                        rate.
                      </Typography>
                    </Box>
                  );
                })()}
            </DialogContent>
            <DialogActions>
              <Button onClick={() => this.setState({ showChangePlan: false })}>
                Cancel
              </Button>
              <Button
                variant="contained"
                onClick={this.handleChangePlan}
                disabled={!this.state.selectedPlanCode}
              >
                {subscription ? "Change" : "Assign"}
              </Button>
            </DialogActions>
          </Dialog>
        )}

        {/* ─── WALLET BALANCES ─── */}
        <Paper variant="outlined" sx={{ p: 2.5, borderRadius: 2 }}>
          <Box sx={sectionHeaderSx}>
            <AccountBalanceWallet sx={sectionIconSx} />
            <Typography variant="subtitle1" fontWeight={600} sx={{ flex: 1 }}>
              Wallet Balances
            </Typography>
            <Button
              size="small"
              variant="contained"
              color="primary"
              sx={{ textTransform: "none", fontWeight: 500, mr: 1 }}
              startIcon={<Add fontSize="small" />}
              onClick={() =>
                this.setState({
                  showCreateWallet: true,
                  createWalletTypes: {},
                  createWalletCredits: "",
                })
              }
            >
              Standard
            </Button>
            <Button
              size="small"
              variant="outlined"
              sx={{ textTransform: "none", fontWeight: 500 }}
              onClick={() =>
                this.setState({
                  showAddPack: true,
                  packChannel: "sms",
                  packMessageType: "",
                })
              }
            >
              Custom Pack
            </Button>
          </Box>

          {wallets.length > 0 ? (
            <>
              <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap", mb: 2 }}>
                {wallets.map((w) => {
                  const isActive =
                    w.status === 1 || w.status === "WALLET_STATUS_ACTIVE";
                  const rate = rateDisplay(w.rateAmount);
                  const inrBalance = (w.balanceCents || 0) / 100;
                  return (
                    <Card
                      key={w.lagoId || w.walletName}
                      variant="outlined"
                      sx={{
                        minWidth: 180,
                        borderRadius: 2,
                        textAlign: "center",
                        position: "relative",
                      }}
                    >
                      <CardContent sx={{ pb: "12px !important" }}>
                        <IconButton
                          size="small"
                          sx={{ position: "absolute", top: 4, right: 4 }}
                          onClick={(e) =>
                            this.setState({
                              walletMenuAnchor: e.currentTarget,
                              walletMenuTarget: w,
                            })
                          }
                        >
                          <MoreVert fontSize="small" />
                        </IconButton>
                        <Typography variant="caption" color="text.secondary">
                          {walletLabel(w.walletName)}
                        </Typography>
                        <Typography
                          variant="h5"
                          fontWeight={700}
                          sx={{ my: 0.5 }}
                        >
                          {Number(w.creditsBalance || 0).toLocaleString(
                            "en-IN",
                          )}
                        </Typography>
                        <Typography variant="caption" color="text.disabled">
                          {inrBalance.toLocaleString("en-IN", {
                            style: "currency",
                            currency: "INR",
                          })}
                        </Typography>
                        <Box
                          sx={{
                            display: "flex",
                            gap: 0.5,
                            justifyContent: "center",
                            mt: 1,
                            flexWrap: "wrap",
                          }}
                        >
                          <Chip
                            label={isActive ? "Active" : "Inactive"}
                            size="small"
                            color={isActive ? "success" : "default"}
                            variant="outlined"
                            sx={{ fontSize: 10 }}
                          />
                          {rate && (
                            <Chip
                              label={`@ ${rate}`}
                              size="small"
                              color="info"
                              variant="outlined"
                              sx={{ fontSize: 10 }}
                            />
                          )}
                          {w.priority != null && (
                            <Chip
                              label={`P${w.priority}`}
                              size="small"
                              variant="outlined"
                              sx={{ fontSize: 10 }}
                            />
                          )}
                        </Box>
                        {isActive && (
                          <Button
                            size="small"
                            variant="outlined"
                            sx={{ mt: 1, fontSize: 11, textTransform: "none" }}
                            onClick={() =>
                              this.setState({
                                showTopUp: true,
                                topUpWallet: w.walletName, // display/lookup
                                topUpLagoId: w.lagoId, // sent to the API (canonical)
                                topUpAmount: "",
                                topUpRemarks: "",
                              })
                            }
                          >
                            Top Up
                          </Button>
                        )}
                      </CardContent>
                    </Card>
                  );
                })}
              </Box>
              <Typography variant="body2" color="text.secondary">
                Total Balance:{" "}
                <strong>
                  {(totalBalanceCents / 100).toLocaleString("en-IN", {
                    style: "currency",
                    currency: "INR",
                  })}
                </strong>{" "}
                (
                {
                  wallets.filter(
                    (w) =>
                      w.status === 1 || w.status === "WALLET_STATUS_ACTIVE",
                  ).length
                }{" "}
                active wallets)
              </Typography>
            </>
          ) : (
            <Typography variant="body2" color="text.secondary">
              No wallets found
            </Typography>
          )}
        </Paper>

        {/* Wallet context menu */}
        <Menu
          anchorEl={this.state.walletMenuAnchor}
          open={Boolean(this.state.walletMenuAnchor)}
          onClose={() =>
            this.setState({ walletMenuAnchor: null, walletMenuTarget: null })
          }
        >
          <MenuItem
            onClick={() => {
              const w = this.state.walletMenuTarget;
              if (!w) return;
              this.setState({
                walletMenuAnchor: null,
                walletMenuTarget: null,
                showEditWallet: true,
                editWalletLagoId: w.lagoId,
                editWalletName: w.walletName,
                editWalletNewName: w.name || "",
                editWalletPriority:
                  w.priority != null ? String(w.priority) : "",
              });
            }}
          >
            <ListItemIcon>
              <EditIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>Edit</ListItemText>
          </MenuItem>
          <MenuItem
            onClick={() => {
              const w = this.state.walletMenuTarget;
              if (!w) return;
              this.setState({
                walletMenuAnchor: null,
                walletMenuTarget: null,
                showVoidCredits: true,
                voidWalletLagoId: w.lagoId,
                voidWalletName: walletLabel(w.walletName),
                voidWalletBalance: w.creditsBalance,
                voidCreditsAmount: "",
              });
            }}
          >
            <ListItemIcon>
              <RemoveCircleOutline fontSize="small" color="warning" />
            </ListItemIcon>
            <ListItemText>Void Credits</ListItemText>
          </MenuItem>
          <MenuItem
            onClick={() => {
              const w = this.state.walletMenuTarget;
              if (!w) return;
              this.setState({
                walletMenuAnchor: null,
                walletMenuTarget: null,
                showTerminateConfirm: true,
                terminateWalletLagoId: w.lagoId,
                terminateWalletName: walletLabel(w.walletName),
                terminateWalletBalance: w.creditsBalance,
                terminateConfirmText: "",
              });
            }}
          >
            <ListItemIcon>
              <Cancel fontSize="small" color="error" />
            </ListItemIcon>
            <ListItemText>Terminate</ListItemText>
          </MenuItem>
        </Menu>

        {/* Edit Wallet Dialog */}
        {this.state.showEditWallet && (
          <Dialog
            open
            onClose={() => this.setState({ showEditWallet: false })}
            maxWidth="xs"
            fullWidth
          >
            <DialogTitle>
              Edit Wallet — {walletLabel(this.state.editWalletName)}
            </DialogTitle>
            <DialogContent
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 16,
                paddingTop: 8,
              }}
            >
              <TextField
                label="Display Name"
                size="small"
                value={this.state.editWalletNewName || ""}
                onChange={(e) =>
                  this.setState({ editWalletNewName: e.target.value })
                }
                sx={{ mt: 1 }}
              />
              <TextField
                label="Priority"
                type="number"
                size="small"
                value={this.state.editWalletPriority || ""}
                onChange={(e) =>
                  this.setState({ editWalletPriority: e.target.value })
                }
                helperText="Lower priority number = deducted first"
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={() => this.setState({ showEditWallet: false })}>
                Cancel
              </Button>
              <Button variant="contained" onClick={this.handleEditWallet}>
                Save
              </Button>
            </DialogActions>
          </Dialog>
        )}

        {/* Terminate wallet confirmation dialog */}
        {this.state.showTerminateConfirm && (
          <Dialog
            open
            onClose={() =>
              this.setState({
                showTerminateConfirm: false,
                terminateConfirmText: "",
              })
            }
            maxWidth="xs"
            fullWidth
          >
            <DialogTitle>Terminate Wallet</DialogTitle>
            <DialogContent
              style={{ display: "flex", flexDirection: "column", gap: 12 }}
            >
              {parseFloat(this.state.terminateWalletBalance || 0) > 0 && (
                <Box
                  sx={{
                    background: "#FFF3E0",
                    border: "1px solid #FFB74D",
                    borderRadius: 2,
                    p: 1.5,
                    fontSize: 13,
                  }}
                >
                  <Typography variant="body2" fontWeight={600} color="#E65100">
                    This wallet has{" "}
                    {Number(this.state.terminateWalletBalance).toLocaleString(
                      "en-IN",
                    )}{" "}
                    credits remaining.
                  </Typography>
                  <Typography variant="body2" color="#BF360C" sx={{ mt: 0.5 }}>
                    Remaining credits will be forfeited. This action cannot be
                    undone.
                  </Typography>
                </Box>
              )}
              <Typography variant="body2">
                To confirm, type{" "}
                <strong style={{ userSelect: "all" }}>
                  {this.state.terminateWalletName}
                </strong>{" "}
                below:
              </Typography>
              <TextField
                size="small"
                autoFocus
                placeholder={this.state.terminateWalletName}
                value={this.state.terminateConfirmText || ""}
                onChange={(e) =>
                  this.setState({ terminateConfirmText: e.target.value })
                }
              />
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() =>
                  this.setState({
                    showTerminateConfirm: false,
                    terminateConfirmText: "",
                  })
                }
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                color="error"
                onClick={this.handleTerminateWallet}
                disabled={
                  (this.state.terminateConfirmText || "") !==
                  this.state.terminateWalletName
                }
              >
                Terminate
              </Button>
            </DialogActions>
          </Dialog>
        )}

        {/* Void Credits Dialog */}
        {this.state.showVoidCredits && (
          <Dialog
            open
            onClose={() => this.setState({ showVoidCredits: false })}
            maxWidth="xs"
            fullWidth
          >
            <DialogTitle>
              Void Credits — {this.state.voidWalletName}
            </DialogTitle>
            <DialogContent
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 16,
                paddingTop: 8,
              }}
            >
              <Typography variant="body2" color="text.secondary">
                Current balance:{" "}
                <strong>
                  {Number(this.state.voidWalletBalance).toLocaleString("en-IN")}{" "}
                  credits
                </strong>
              </Typography>
              <TextField
                label="Credits to Void"
                type="number"
                size="small"
                autoFocus
                value={this.state.voidCreditsAmount || ""}
                onChange={(e) =>
                  this.setState({ voidCreditsAmount: e.target.value })
                }
                helperText="Voided credits are deducted from balance without usage consumption"
                sx={{ mt: 1 }}
              />
              <TextField
                label="Remarks (optional)"
                size="small"
                value={this.state.voidRemarks || ""}
                onChange={(e) => this.setState({ voidRemarks: e.target.value })}
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={() => this.setState({ showVoidCredits: false })}>
                Cancel
              </Button>
              <Button
                variant="contained"
                color="warning"
                onClick={this.handleVoidWalletCredits}
                disabled={
                  !this.state.voidCreditsAmount ||
                  Number(this.state.voidCreditsAmount) <= 0
                }
              >
                Void Credits
              </Button>
            </DialogActions>
          </Dialog>
        )}

        {/* Top Up Dialog */}
        {showTopUp &&
          (() => {
            const topUpW = wallets.find(
              (w) => w.walletName === this.state.topUpWallet,
            );
            const topUpRate = topUpW ? rateDisplay(topUpW.rateAmount) : null;
            return (
              <Dialog
                open
                onClose={() => this.setState({ showTopUp: false })}
                maxWidth="xs"
                fullWidth
              >
                <DialogTitle>
                  Top Up — {walletLabel(this.state.topUpWallet)}
                </DialogTitle>
                <DialogContent
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 16,
                    paddingTop: 8,
                  }}
                >
                  {topUpRate && (
                    <Typography variant="body2" color="text.secondary">
                      Rate: <strong>{topUpRate}</strong> · To add credits at a
                      different rate, use <em>Custom Pack</em>.
                    </Typography>
                  )}
                  <Autocomplete
                    freeSolo
                    options={CREDIT_PRESETS}
                    filterOptions={(x) => x}
                    getOptionLabel={(o) => (typeof o === "string" ? o : o.value)}
                    renderOption={(props, o) => (
                      <li {...props} key={o.label}>
                        {o.label}&nbsp;
                        <Typography variant="body2" color="text.secondary" component="span">
                          — {Number(o.value).toLocaleString("en-IN")}
                        </Typography>
                      </li>
                    )}
                    inputValue={this.state.topUpAmount || ""}
                    onInputChange={(e, v) =>
                      // digits only — presets fill their numeric value, typed
                      // input is sanitized in place
                      this.setState({ topUpAmount: (v || "").replace(/\D/g, "") })
                    }
                    onChange={(e, v) => {
                      if (v && typeof v === "object") this.setState({ topUpAmount: v.value });
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Credits (number of SMS)"
                        size="small"
                        autoFocus
                      />
                    )}
                  />
                  {this.state.topUpAmount > 0 && topUpW?.rateAmount > 0 && (
                    <Typography variant="body2" color="primary" sx={{ mt: -1 }}>
                      ={" "}
                      {(
                        this.state.topUpAmount * parseFloat(topUpW.rateAmount)
                      ).toLocaleString("en-IN", {
                        style: "currency",
                        currency: "INR",
                      })}{" "}
                      ({this.state.topUpAmount} × {topUpRate})
                    </Typography>
                  )}
                  <TextField
                    label="Remarks (optional)"
                    size="small"
                    value={this.state.topUpRemarks || ""}
                    onChange={(e) =>
                      this.setState({ topUpRemarks: e.target.value })
                    }
                  />
                </DialogContent>
                <DialogActions>
                  <Button onClick={() => this.setState({ showTopUp: false })}>
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    onClick={this.handleBillingTopUp}
                    disabled={!this.state.topUpAmount}
                  >
                    Top Up
                  </Button>
                </DialogActions>
              </Dialog>
            );
          })()}

        {/* Create Wallet Dialog */}
        {showCreateWallet && (
          <Dialog
            open
            onClose={() => this.setState({ showCreateWallet: false })}
            maxWidth="xs"
            fullWidth
          >
            <DialogTitle>Create Standard Wallets</DialogTitle>
            <DialogContent
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 16,
                paddingTop: 8,
              }}
            >
              <FormControl component="fieldset" sx={{ mt: 1 }}>
                <FormLabel component="legend">Select wallet types</FormLabel>
                <FormGroup>
                  {allWalletTypes.map((t) => {
                    const exists = existingTypes.includes(t);
                    const prio = priorityByType[t];
                    return (
                      <FormControlLabel
                        key={t}
                        disabled={exists}
                        control={
                          <Checkbox
                            checked={
                              !exists &&
                              !!(this.state.createWalletTypes || {})[t]
                            }
                            disabled={exists}
                            onChange={(e) =>
                              this.setState({
                                createWalletTypes: {
                                  ...this.state.createWalletTypes,
                                  [t]: e.target.checked,
                                },
                              })
                            }
                          />
                        }
                        label={
                          t.charAt(0).toUpperCase() +
                          t.slice(1) +
                          (exists
                            ? ` — already active${
                                prio != null ? ` (P${prio})` : ""
                              }`
                            : "")
                        }
                      />
                    );
                  })}
                </FormGroup>
                {availableTypes.length === 0 && (
                  <FormHelperText>
                    All standard wallets exist. To add another wallet for a
                    message type at a different priority or rate, use{" "}
                    <strong>Custom Pack</strong>.
                  </FormHelperText>
                )}
              </FormControl>
              <TextField
                label="Initial Credits (optional)"
                type="number"
                size="small"
                value={this.state.createWalletCredits || ""}
                onChange={(e) =>
                  this.setState({ createWalletCredits: e.target.value })
                }
                helperText="Credits to add per wallet. Leave 0 for empty wallets."
              />
              <TextField
                label="Remarks (optional)"
                size="small"
                value={this.state.createWalletRemarks || ""}
                onChange={(e) =>
                  this.setState({ createWalletRemarks: e.target.value })
                }
              />
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => this.setState({ showCreateWallet: false })}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                onClick={this.handleCreateWallets}
                disabled={
                  !Object.values(this.state.createWalletTypes || {}).some(
                    Boolean,
                  )
                }
              >
                Create
              </Button>
            </DialogActions>
          </Dialog>
        )}

        {/* Add Custom Pack Dialog */}
        {this.state.showAddPack &&
          (() => {
            const usedPriorities = wallets
              .filter(
                (w) =>
                  w.priority != null &&
                  (w.status === 1 || w.status === "WALLET_STATUS_ACTIVE"),
              )
              .map((w) => w.priority);
            const suggestedPriority =
              usedPriorities.length > 0 ? Math.max(...usedPriorities) + 1 : 1;
            return (
              <Dialog
                open
                onClose={() => this.setState({ showAddPack: false })}
                maxWidth="xs"
                fullWidth
              >
                <DialogTitle>Add Custom Pack</DialogTitle>
                <DialogContent
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 16,
                    paddingTop: 8,
                  }}
                >
                  <Box sx={{ display: "flex", gap: 1.5 }}>
                    <FormControl size="small" sx={{ mt: 1, minWidth: 120 }}>
                      <InputLabel>Channel</InputLabel>
                      <Select
                        value={this.state.packChannel || "sms"}
                        label="Channel"
                        onChange={(e) =>
                          this.setState({ packChannel: e.target.value })
                        }
                      >
                        <MenuItem value="sms">SMS</MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl size="small" sx={{ mt: 1, flex: 1 }}>
                      <InputLabel>Message Type</InputLabel>
                      <Select
                        value={this.state.packMessageType || ""}
                        label="Message Type"
                        onChange={(e) =>
                          this.setState({ packMessageType: e.target.value })
                        }
                      >
                        <MenuItem value="transactional">Transactional</MenuItem>
                        <MenuItem value="promotional">Promotional</MenuItem>
                        <MenuItem value="otp">OTP</MenuItem>
                      </Select>
                    </FormControl>
                  </Box>
                  <TextField
                    label="Pack Name"
                    size="small"
                    placeholder="e.g., Pro Pack - 100K SMS"
                    value={this.state.packName || ""}
                    onChange={(e) =>
                      this.setState({ packName: e.target.value })
                    }
                  />
                  <TextField
                    label="Rate per SMS (INR)"
                    type="number"
                    size="small"
                    placeholder="e.g., 0.14"
                    value={this.state.packRate || ""}
                    onChange={(e) =>
                      this.setState({ packRate: e.target.value })
                    }
                    helperText="Per-unit rate in INR (e.g., 0.14 = 14 paise/SMS)"
                  />
                  <TextField
                    label="Credits"
                    type="number"
                    size="small"
                    placeholder="e.g., 100000"
                    value={this.state.packCredits || ""}
                    onChange={(e) =>
                      this.setState({ packCredits: e.target.value })
                    }
                  />
                  <TextField
                    label="Priority"
                    type="number"
                    size="small"
                    placeholder={String(suggestedPriority)}
                    value={this.state.packPriority || ""}
                    onChange={(e) =>
                      this.setState({ packPriority: e.target.value })
                    }
                    helperText={`Deducted lowest first. Used: ${usedPriorities.length > 0 ? usedPriorities.sort((a, b) => a - b).join(", ") : "none"}`}
                  />
                  <TextField
                    label="Remarks (optional)"
                    size="small"
                    value={this.state.packRemarks || ""}
                    onChange={(e) =>
                      this.setState({ packRemarks: e.target.value })
                    }
                  />
                </DialogContent>
                <DialogActions>
                  <Button onClick={() => this.setState({ showAddPack: false })}>
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    onClick={this.handleCreateCustomWallet}
                    disabled={
                      !this.state.packName ||
                      !this.state.packRate ||
                      !this.state.packCredits ||
                      !this.state.packPriority ||
                      !this.state.packMessageType
                    }
                  >
                    Create Pack
                  </Button>
                </DialogActions>
              </Dialog>
            );
          })()}

        {/* ─── PLANS MANAGEMENT ─── */}
        <Paper variant="outlined" sx={{ p: 2.5, borderRadius: 2 }}>
          <Box sx={sectionHeaderSx}>
            <ChromeReaderMode sx={sectionIconSx} />
            <Typography variant="subtitle1" fontWeight={600} sx={{ flex: 1 }}>
              Plans
            </Typography>
            <Button
              size="small"
              variant="contained"
              color="primary"
              sx={{ textTransform: "none", fontWeight: 500 }}
              startIcon={<AddCircleOutline fontSize="small" />}
              onClick={() =>
                this.setState({
                  showCreatePlan: true,
                  newPlanName: "",
                  newPlanCode: "",
                  newPlanInterval: "yearly",
                  newPlanAmount: "",
                  newPlanCurrency: "INR",
                  newPlanSmsRate: "",
                })
              }
            >
              Create Plan
            </Button>
          </Box>

          {plans.length > 0 ? (
            <Box sx={{ overflowX: "auto" }}>
              <table
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  fontSize: 13,
                }}
              >
                <thead>
                  <tr
                    style={{
                      borderBottom: "2px solid #e0e0e0",
                      textAlign: "left",
                    }}
                  >
                    <th style={{ padding: "8px 12px" }}>Name</th>
                    <th style={{ padding: "8px 12px" }}>Code</th>
                    <th style={{ padding: "8px 12px" }}>Interval</th>
                    <th style={{ padding: "8px 12px" }}>SMS Rate</th>
                    <th style={{ padding: "8px 12px" }}>Fee</th>
                    <th style={{ padding: "8px 12px", width: 100 }}>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {plans.map((p) => {
                    const rate = planRateDisplay(p);
                    const isCurrentPlan = subscription?.planCode === p.code;
                    return (
                      <tr
                        key={p.code}
                        style={{
                          borderBottom: "1px solid #f0f0f0",
                          backgroundColor: isCurrentPlan
                            ? "#f0f7ff"
                            : "transparent",
                        }}
                      >
                        <td
                          style={{
                            padding: "8px 12px",
                            fontWeight: isCurrentPlan ? 600 : 400,
                          }}
                        >
                          {p.name}
                          {isCurrentPlan && (
                            <Chip
                              label="Current"
                              size="small"
                              color="primary"
                              variant="outlined"
                              sx={{ ml: 1, fontSize: 10, height: 20 }}
                            />
                          )}
                        </td>
                        <td style={{ padding: "8px 12px" }}>
                          <code
                            style={{
                              fontSize: 12,
                              background: "#f5f5f5",
                              padding: "2px 6px",
                              borderRadius: 4,
                            }}
                          >
                            {p.code}
                          </code>
                        </td>
                        <td style={{ padding: "8px 12px" }}>
                          {p.interval || "-"}
                        </td>
                        <td style={{ padding: "8px 12px" }}>
                          {rate ? (
                            <Chip
                              label={`${rate}/SMS`}
                              size="small"
                              color="info"
                              variant="outlined"
                              sx={{ fontSize: 11 }}
                            />
                          ) : (
                            "-"
                          )}
                        </td>
                        <td style={{ padding: "8px 12px" }}>
                          {p.amountCents && p.amountCents !== "0"
                            ? (
                                parseInt(p.amountCents, 10) / 100
                              ).toLocaleString("en-IN", {
                                style: "currency",
                                currency: p.currency || "INR",
                              })
                            : "Free"}
                        </td>
                        <td style={{ padding: "8px 12px" }}>
                          <Tooltip title="Edit Plan">
                            <IconButton
                              size="small"
                              onClick={() =>
                                this.setState({
                                  showEditPlan: true,
                                  editPlanCode: p.code,
                                  editPlanName: p.name,
                                  editPlanInterval: p.interval || "yearly",
                                  editPlanAmount: p.amountCents
                                    ? String(parseInt(p.amountCents, 10) / 100)
                                    : "0",
                                  editPlanCurrency: p.currency || "INR",
                                  editPlanSmsRate: p.smsRate || "",
                                })
                              }
                            >
                              <EditIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                          <Tooltip
                            title={
                              isCurrentPlan
                                ? "Cannot delete active plan"
                                : "Delete Plan"
                            }
                          >
                            <span>
                              <IconButton
                                size="small"
                                color="error"
                                disabled={isCurrentPlan}
                                onClick={() =>
                                  this.setState({
                                    showDeletePlan: true,
                                    deletePlanCode: p.code,
                                    deletePlanName: p.name,
                                  })
                                }
                              >
                                <DeleteIcon fontSize="small" />
                              </IconButton>
                            </span>
                          </Tooltip>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </Box>
          ) : (
            <Typography variant="body2" color="text.secondary">
              No plans found
            </Typography>
          )}
        </Paper>

        {/* Create Plan Dialog */}
        {this.state.showCreatePlan && (
          <Dialog
            open
            onClose={() => this.setState({ showCreatePlan: false })}
            maxWidth="sm"
            fullWidth
          >
            <DialogTitle>Create Plan</DialogTitle>
            <DialogContent
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 16,
                paddingTop: 8,
              }}
            >
              <TextField
                label="Plan Name"
                size="small"
                autoFocus
                sx={{ mt: 1 }}
                value={this.state.newPlanName || ""}
                placeholder="e.g., Growth"
                onChange={(e) => this.setState({ newPlanName: e.target.value })}
              />
              <TextField
                label="Plan Code"
                size="small"
                value={this.state.newPlanCode || ""}
                placeholder="e.g., growth"
                onChange={(e) => this.setState({ newPlanCode: e.target.value })}
                helperText="Unique identifier. Use lowercase, no spaces."
              />
              <Box sx={{ display: "flex", gap: 1.5 }}>
                <FormControl size="small" sx={{ minWidth: 140 }}>
                  <InputLabel>Interval</InputLabel>
                  <Select
                    value={this.state.newPlanInterval || "yearly"}
                    label="Interval"
                    onChange={(e) =>
                      this.setState({ newPlanInterval: e.target.value })
                    }
                  >
                    <MenuItem value="weekly">Weekly</MenuItem>
                    <MenuItem value="monthly">Monthly</MenuItem>
                    <MenuItem value="quarterly">Quarterly</MenuItem>
                    <MenuItem value="yearly">Yearly</MenuItem>
                  </Select>
                </FormControl>
                <FormControl size="small" sx={{ minWidth: 100 }}>
                  <InputLabel>Currency</InputLabel>
                  <Select
                    value={this.state.newPlanCurrency || "INR"}
                    label="Currency"
                    onChange={(e) =>
                      this.setState({ newPlanCurrency: e.target.value })
                    }
                  >
                    <MenuItem value="INR">INR</MenuItem>
                    <MenuItem value="USD">USD</MenuItem>
                  </Select>
                </FormControl>
              </Box>
              <TextField
                label="Plan Fee (INR)"
                type="number"
                size="small"
                placeholder="0"
                value={this.state.newPlanAmount || ""}
                onChange={(e) =>
                  this.setState({ newPlanAmount: e.target.value })
                }
                helperText="Subscription fee per billing period. 0 for free plan."
              />
              <TextField
                label="SMS Rate (INR per SMS)"
                type="number"
                size="small"
                placeholder="e.g., 0.16"
                value={this.state.newPlanSmsRate || ""}
                onChange={(e) =>
                  this.setState({ newPlanSmsRate: e.target.value })
                }
                helperText="Default rate for wallets created under this plan."
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={() => this.setState({ showCreatePlan: false })}>
                Cancel
              </Button>
              <Button
                variant="contained"
                onClick={this.handleCreatePlan}
                disabled={!this.state.newPlanName || !this.state.newPlanCode}
              >
                Create
              </Button>
            </DialogActions>
          </Dialog>
        )}

        {/* Edit Plan Dialog */}
        {this.state.showEditPlan && (
          <Dialog
            open
            onClose={() => this.setState({ showEditPlan: false })}
            maxWidth="sm"
            fullWidth
          >
            <DialogTitle>Edit Plan — {this.state.editPlanCode}</DialogTitle>
            <DialogContent
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 16,
                paddingTop: 8,
              }}
            >
              <TextField
                label="Plan Name"
                size="small"
                sx={{ mt: 1 }}
                value={this.state.editPlanName || ""}
                onChange={(e) =>
                  this.setState({ editPlanName: e.target.value })
                }
              />
              <Box sx={{ display: "flex", gap: 1.5 }}>
                <FormControl size="small" sx={{ minWidth: 140 }}>
                  <InputLabel>Interval</InputLabel>
                  <Select
                    value={this.state.editPlanInterval || "yearly"}
                    label="Interval"
                    onChange={(e) =>
                      this.setState({ editPlanInterval: e.target.value })
                    }
                  >
                    <MenuItem value="weekly">Weekly</MenuItem>
                    <MenuItem value="monthly">Monthly</MenuItem>
                    <MenuItem value="quarterly">Quarterly</MenuItem>
                    <MenuItem value="yearly">Yearly</MenuItem>
                  </Select>
                </FormControl>
                <FormControl size="small" sx={{ minWidth: 100 }}>
                  <InputLabel>Currency</InputLabel>
                  <Select
                    value={this.state.editPlanCurrency || "INR"}
                    label="Currency"
                    onChange={(e) =>
                      this.setState({ editPlanCurrency: e.target.value })
                    }
                  >
                    <MenuItem value="INR">INR</MenuItem>
                    <MenuItem value="USD">USD</MenuItem>
                  </Select>
                </FormControl>
              </Box>
              <TextField
                label="Plan Fee"
                type="number"
                size="small"
                value={this.state.editPlanAmount || ""}
                onChange={(e) =>
                  this.setState({ editPlanAmount: e.target.value })
                }
              />
              <TextField
                label="SMS Rate (INR per SMS)"
                type="number"
                size="small"
                value={this.state.editPlanSmsRate || ""}
                onChange={(e) =>
                  this.setState({ editPlanSmsRate: e.target.value })
                }
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={() => this.setState({ showEditPlan: false })}>
                Cancel
              </Button>
              <Button variant="contained" onClick={this.handleUpdatePlan}>
                Save
              </Button>
            </DialogActions>
          </Dialog>
        )}

        {/* Delete Plan Dialog */}
        {this.state.showDeletePlan && (
          <Dialog
            open
            onClose={() => this.setState({ showDeletePlan: false })}
            maxWidth="xs"
            fullWidth
          >
            <DialogTitle>Delete Plan</DialogTitle>
            <DialogContent>
              <Typography variant="body2">
                Are you sure you want to delete{" "}
                <strong>{this.state.deletePlanName}</strong> (
                <code>{this.state.deletePlanCode}</code>)? This action cannot be
                undone.
              </Typography>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => this.setState({ showDeletePlan: false })}>
                Cancel
              </Button>
              <Button
                variant="contained"
                color="error"
                onClick={this.handleDeletePlan}
              >
                Delete
              </Button>
            </DialogActions>
          </Dialog>
        )}

        {/* ─── RECENT TRANSACTIONS ─── */}
        <Paper variant="outlined" sx={{ p: 2.5, borderRadius: 2 }}>
          <Box sx={sectionHeaderSx}>
            <Receipt sx={sectionIconSx} />
            <Typography variant="subtitle1" fontWeight={600}>
              Recent Transactions
            </Typography>
          </Box>

          {transactions.length > 0 ? (
            <Box sx={{ overflowX: "auto" }}>
              <table
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  fontSize: 13,
                }}
              >
                <thead>
                  <tr
                    style={{
                      borderBottom: "2px solid #e0e0e0",
                      textAlign: "left",
                    }}
                  >
                    <th style={{ padding: "8px 12px" }}>Date</th>
                    <th style={{ padding: "8px 12px" }}>Operation</th>
                    <th style={{ padding: "8px 12px" }}>Wallet</th>
                    <th style={{ padding: "8px 12px" }}>Credits</th>
                    <th style={{ padding: "8px 12px" }}>Previous Balance</th>
                    <th style={{ padding: "8px 12px" }}>Current Balance</th>
                    <th style={{ padding: "8px 12px" }}>Status</th>
                    <th style={{ padding: "8px 12px" }}>Remarks</th>
                  </tr>
                </thead>
                <tbody>
                  {transactions.slice(0, 20).map((t, i) => {
                    const d = t.createdAt?.seconds
                      ? new Date(t.createdAt.seconds * 1000)
                      : t.createdAt
                        ? new Date(t.createdAt)
                        : null;
                    return (
                      <tr
                        key={t.lagoId || i}
                        style={{ borderBottom: "1px solid #f0f0f0" }}
                      >
                        <td style={{ padding: "8px 12px" }}>
                          {d && !isNaN(d.getTime())
                            ? dateFormat(d.toISOString())
                            : "-"}
                        </td>
                        <td style={{ padding: "8px 12px" }}>
                          <Chip
                            label={
                              t.transactionType === "inbound"
                                ? "CREDITED"
                                : "DEBITED"
                            }
                            size="small"
                            color={
                              t.transactionType === "inbound"
                                ? "success"
                                : "error"
                            }
                            variant="outlined"
                            sx={{ fontSize: 11 }}
                          />
                        </td>
                        <td style={{ padding: "8px 12px" }}>
                          {walletLabel(t.walletName)}
                        </td>
                        <td style={{ padding: "8px 12px" }}>
                          {Number(t.creditAmount || 0).toLocaleString("en-IN")}
                        </td>
                        <td style={{ padding: "8px 12px" }}>
                          {t.previousBalance != null && t.previousBalance !== ""
                            ? Number(t.previousBalance).toLocaleString("en-IN")
                            : "-"}
                        </td>
                        <td style={{ padding: "8px 12px" }}>
                          {t.currentBalance != null && t.currentBalance !== ""
                            ? Number(t.currentBalance).toLocaleString("en-IN")
                            : "-"}
                        </td>
                        <td style={{ padding: "8px 12px" }}>
                          {t.status || "-"}
                        </td>
                        <td style={{ padding: "8px 12px" }}>{t.remarks || t.name || "-"}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </Box>
          ) : (
            <Typography variant="body2" color="text.secondary">
              No transactions yet
            </Typography>
          )}
        </Paper>

      </Box>
    );
  }

  // ── Account / Lifecycle Tab ──────────────────────────
  renderAccountTab() {
    const {
      accountStatus,
      statusHistory,
      accountSubscriptions,
      accountEntitlements,
    } = this.props;
    // handleAPIDispatch stores the full HTTP body in redux: { success, data: {...} }.
    // Each section unwraps `.data` so we read the actual fields.
    // (Pre-fix: this was reading top-level `.account`/`.subscriptions`/etc.,
    // which never existed in the stored shape — UI rendered "No data found"
    // even for tenants that had a complete lifecycle row.)
    const acct = accountStatus?.data?.account;
    const subs =
      accountSubscriptions?.data?.subscriptions ||
      accountStatus?.data?.subscriptions ||
      [];
    const history = statusHistory?.data?.entries || [];
    const ents = accountEntitlements?.data?.entitlements || [];

    const statusColor = {
      trial: "#ff9800",
      active: "#4caf50",
      blocked: "#f44336",
      terminated: "#9e9e9e",
    };

    const subStatusColor = {
      trialing: "#ff9800",
      active: "#4caf50",
      past_due: "#ff5722",
      paused: "#9e9e9e",
      canceled: "#f44336",
      expired: "#795548",
    };

    return (
      <Box>
        {/* Account Status Card */}
        <Card variant="outlined" sx={{ mb: 2 }}>
          <CardContent>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 1 }}>
              <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
                Account Status
              </Typography>
              {/* Change Status — transitions an EXISTING lifecycle account
                  (active/blocked/terminated) via TransitionAccountWithAudit.
                  Per docs/ADR_TENANT_STATUS_AND_TIER.md this is the BILLING
                  layer; identity (IAM) state is changed per-user from the Users
                  tab and tier is the rate-limit axis — both independent. Only
                  shown when an account exists: 'trial' is an entry state, not a
                  transition target, so the initial trial account is created via
                  "Start Trial" below, not here. */}
              {acct && (
                <Button
                  size="small"
                  variant="outlined"
                  onClick={this.openChangeStatus}
                >
                  Change Status
                </Button>
              )}
            </Box>
            {!acct ? (
              <Box>
                <Typography color="text.secondary" sx={{ mb: 1.5 }}>
                  No lifecycle account yet. This tenant bypassed onboarding's
                  lifecycle step (e.g. created via support/backfill). Start its
                  billing-layer trial — independent of IAM state and tier.
                </Typography>
                <Button
                  variant="contained"
                  size="small"
                  color="primary"
                  startIcon={
                    this.state.lifecycleSetupLoading ? (
                      <CircularProgress size={14} color="inherit" />
                    ) : (
                      <PlayArrow />
                    )
                  }
                  onClick={this.handleRunLifecycleSetup}
                  disabled={this.state.lifecycleSetupLoading}
                  sx={{ textTransform: "none" }}
                >
                  {this.state.lifecycleSetupLoading
                    ? "Starting trial..."
                    : "Start Trial (Run Lifecycle Setup)"}
                </Button>
              </Box>
            ) : (
              <Box>
                <Box
                  sx={{ display: "flex", alignItems: "center", gap: 2, mb: 1 }}
                >
                  <Chip
                    label={acct.accountStatus}
                    sx={{
                      bgcolor: statusColor[acct.accountStatus] || "#9e9e9e",
                      color: "#fff",
                      fontWeight: "bold",
                    }}
                  />
                  <Typography variant="body2" color="text.secondary">
                    Source: {acct.statusSource}
                  </Typography>
                  {acct.statusReason && (
                    <Typography variant="body2" color="text.secondary">
                      Reason: {acct.statusReason}
                    </Typography>
                  )}
                </Box>
                <Box sx={{ display: "flex", gap: 3, flexWrap: "wrap", mt: 1 }}>
                  {acct.trialStartAt && (
                    <Typography variant="caption">
                      Trial: {dateFormat(acct.trialStartAt)} -{" "}
                      {dateFormat(acct.trialEndAt)}
                    </Typography>
                  )}
                  {acct.gracePeriodEndAt && (
                    <Typography variant="caption">
                      Grace until: {dateFormat(acct.gracePeriodEndAt)}
                    </Typography>
                  )}
                  {acct.activatedAt && (
                    <Typography variant="caption">
                      Activated: {dateFormat(acct.activatedAt)}
                    </Typography>
                  )}
                  {acct.blockedAt && (
                    <Typography variant="caption">
                      Blocked: {dateFormat(acct.blockedAt)}
                    </Typography>
                  )}
                  {acct.terminatedAt && (
                    <Typography variant="caption">
                      Terminated: {dateFormat(acct.terminatedAt)}
                    </Typography>
                  )}
                </Box>
              </Box>
            )}
          </CardContent>
        </Card>

        {/* Subscriptions */}
        <Card variant="outlined" sx={{ mb: 2 }}>
          <CardContent>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 1 }}>
              Subscriptions
            </Typography>
            {subs.length === 0 ? (
              <Typography color="text.secondary">
                No subscriptions found.
              </Typography>
            ) : (
              subs.map((sub, i) => (
                <Box
                  key={i}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                    mb: 1,
                    p: 1,
                    bgcolor: "#f5f5f5",
                    borderRadius: 1,
                  }}
                >
                  <Chip
                    label={sub.subscriptionStatus}
                    size="small"
                    sx={{
                      bgcolor:
                        subStatusColor[sub.subscriptionStatus] || "#9e9e9e",
                      color: "#fff",
                    }}
                  />
                  <Typography variant="body2">
                    <strong>{sub.planCode}</strong>
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {sub.productCode}/{sub.channelCode || "all"}
                  </Typography>
                  {sub.currentPeriodStart && (
                    <Typography variant="caption" color="text.secondary">
                      Period: {dateFormat(sub.currentPeriodStart)} -{" "}
                      {dateFormat(sub.currentPeriodEnd)}
                    </Typography>
                  )}
                </Box>
              ))
            )}
          </CardContent>
        </Card>

        {/* Entitlements */}
        {ents.length > 0 && (
          <Card variant="outlined" sx={{ mb: 2 }}>
            <CardContent>
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: "bold", mb: 1 }}
              >
                Entitlements (
                {accountEntitlements?.planName || accountEntitlements?.planCode}
                )
              </Typography>
              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                {ents.map((ent, i) => (
                  <Chip
                    key={i}
                    label={`${ent.featureCode} ${ent.isEnabled ? (ent.limitValue ? `(${ent.limitValue}/${ent.limitInterval})` : "(unlimited)") : "(disabled)"}`}
                    color={ent.isEnabled ? "primary" : "default"}
                    variant={ent.isEnabled ? "filled" : "outlined"}
                    size="small"
                  />
                ))}
              </Box>
            </CardContent>
          </Card>
        )}

        {/* Status History / Audit Trail */}
        <Card variant="outlined">
          <CardContent>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 1 }}>
              Status History
            </Typography>
            {history.length === 0 ? (
              <Typography color="text.secondary">
                No status changes recorded.
              </Typography>
            ) : (
              <Box sx={{ maxHeight: 300, overflow: "auto" }}>
                {history.map((entry, i) => (
                  <Box
                    key={i}
                    sx={{
                      display: "flex",
                      alignItems: "flex-start",
                      gap: 1,
                      mb: 1,
                      p: 1,
                      borderBottom: "1px solid #eee",
                    }}
                  >
                    <ChangeHistory
                      fontSize="small"
                      sx={{ color: "#666", mt: 0.5 }}
                    />
                    <Box sx={{ flex: 1 }}>
                      <Box
                        sx={{ display: "flex", gap: 1, alignItems: "center" }}
                      >
                        {entry.oldAccountStatus && (
                          <Chip
                            label={entry.oldAccountStatus}
                            size="small"
                            variant="outlined"
                          />
                        )}
                        {entry.oldAccountStatus && entry.newAccountStatus && (
                          <Typography variant="body2">→</Typography>
                        )}
                        {entry.newAccountStatus && (
                          <Chip
                            label={entry.newAccountStatus}
                            size="small"
                            sx={{
                              bgcolor:
                                statusColor[entry.newAccountStatus] ||
                                "#9e9e9e",
                              color: "#fff",
                            }}
                          />
                        )}
                        {entry.newSubscriptionStatus && (
                          <Chip
                            label={`sub: ${entry.newSubscriptionStatus}`}
                            size="small"
                            variant="outlined"
                          />
                        )}
                        {entry.newPlanCode && (
                          <Chip
                            label={`plan: ${entry.newPlanCode}`}
                            size="small"
                            variant="outlined"
                          />
                        )}
                      </Box>
                      <Typography variant="caption" color="text.secondary">
                        {dateFormat(entry.createdAt)} | {entry.source}
                        {entry.sourceRef ? ` (${entry.sourceRef})` : ""}
                        {entry.reason ? ` — ${entry.reason}` : ""}
                      </Typography>
                    </Box>
                  </Box>
                ))}
              </Box>
            )}
          </CardContent>
        </Card>
      </Box>
    );
  }

  // Admin Panel read-only Webhooks view. Customer-facing CRUD lives in
  // Developers Tool (src/views/DevelopersTool/WebhooksTab.jsx) — support
  // staff drills into a tenant here for audit only.
  //
  // Current state: the Go CRUD + Rust pipeline for webhooks are shipped, but
  // a tenant-scoped admin endpoint (`/api/v1/support/tenants/{tenantId}/webhook_configs`)
  // doesn't exist yet. We show a placeholder that links to the standard
  // Developers Tool so support can still see the state by impersonating, and
  // flag the missing backend for follow-up.
  renderWebhooksTab() {
    const {data} = this.props;
    return (
      <Box>
        <Card>
          <CardContent>
            <Typography variant="h6" gutterBottom>Webhooks</Typography>
            <Typography variant="body2" color="textSecondary" gutterBottom>
              Tenant: <code>{data?.instituteId || '-'}</code>
            </Typography>
            <Alert severity="info" style={{marginTop: 12}}>
              Tenant-scoped admin view pending backend support. For now, open
              the tenant's Developers Tool via impersonation to see + edit
              their webhook configuration. Read-only drill-in will land here
              once <code>/api/v1/support/tenants/{'{tenantId}'}/webhook_configs</code>
              {' '}is implemented.
            </Alert>
            <Typography variant="body2" style={{marginTop: 12}} color="textSecondary">
              Webhook configuration includes: workspace, webhook type
              (sms_delivery), target URL, HTTP method, headers, active flag,
              retry settings, and optional event filter. Currently exposed via
              the customer-facing <code>WebhookConfigService</code> gRPC.
            </Typography>
          </CardContent>
        </Card>

      </Box>
    );
  }

  // Rate Limits tab — tenant-scoped tier + override management. Full admin
  // page lives at /rate-limits (admin-only); this drill-in lets a support
  // agent adjust rate limits while impersonating a tenant.
  renderRateLimitsTab() {
    const { data, tenantRateLimit } = this.props;
    const detail = tenantRateLimit?.data;
    const tenant = detail?.tenant;
    const overrides = detail?.overrides || [];
    return (
      <Box>
        <Card>
          <CardContent>
            <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
              <Typography variant="h6" sx={{ flex: 1 }}>Rate Limits</Typography>
              <Tooltip title="Refresh">
                <IconButton size="small" onClick={() => this.props.getTenantRateLimit(data?.instituteId)}>
                  <Refresh fontSize="small" />
                </IconButton>
              </Tooltip>
            </Box>
            <Typography variant="body2" color="textSecondary" gutterBottom>
              Tenant: <code>{data?.instituteId || "-"}</code>
            </Typography>
            <Box sx={{ display: "flex", alignItems: "center", gap: 2, mt: 2, mb: 2, flexWrap: "wrap" }}>
              <Typography variant="body2">Tier:</Typography>
              <Chip label={tenant?.rateLimitTier || "normal"} size="small" />
              <Button size="small" onClick={this.openRlTierDialog}>Set tier</Button>
              <Box sx={{ flex: 1 }} />
              <Button size="small" startIcon={<Add />} variant="outlined" onClick={this.openRlOverrideDialog}>
                Add override
              </Button>
            </Box>
            <Divider sx={{ my: 1 }} />
            <Typography variant="subtitle2" sx={{ mt: 1, mb: 1 }}>
              Active overrides ({overrides.length})
            </Typography>
            {overrides.length === 0 && (
              <Typography variant="caption" color="textSecondary">
                No overrides — tier template applies.
              </Typography>
            )}
            {overrides.map((o) => (
              <Box key={o.id || o.scope} sx={{ display: "flex", alignItems: "center", gap: 2, py: 0.5 }}>
                <Chip label={o.scope} size="small" variant="outlined" />
                <Typography variant="caption">
                  cap={o.capacity}, fill={o.fillRate}/{o.fillIntervalSecs}s
                </Typography>
                {o.reason && (
                  <Typography variant="caption" color="textSecondary">— {o.reason}</Typography>
                )}
                <Box sx={{ flex: 1 }} />
                <IconButton size="small" onClick={() => this.removeRlOverride(o.scope)}>
                  <DeleteIcon fontSize="small" />
                </IconButton>
              </Box>
            ))}
            <Typography variant="caption" color="textSecondary" sx={{ display: "block", mt: 2 }}>
              Picks up within ~60s on every RLQS replica. No redeploy needed.
            </Typography>
          </CardContent>
        </Card>

      </Box>
    );
  }

  renderRlTierDialog() {
    const { open, tier } = this.state.rlTierDialog;
    if (!open) return null;
    const { data } = this.props;
    return (
      <Dialog open onClose={this.closeRlTierDialog} maxWidth="xs" fullWidth>
        <DialogTitle>Set tier — {data?.name}</DialogTitle>
        <DialogContent>
          <FormControl fullWidth margin="dense">
            <InputLabel>Tier</InputLabel>
            <Select
              label="Tier"
              value={tier}
              onChange={(e) => this.setState((s) => ({ rlTierDialog: { ...s.rlTierDialog, tier: e.target.value } }))}
            >
              {RL_TIERS.map((t) => (
                <MenuItem key={t} value={t}>{t}</MenuItem>
              ))}
            </Select>
          </FormControl>
          <Typography variant="caption" color="textSecondary" sx={{ mt: 1, display: "block" }}>
            Picks up within ~60s on every RLQS replica. No redeploy needed.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.closeRlTierDialog}>Cancel</Button>
          <Button onClick={this.submitRlTier} variant="contained">Save</Button>
        </DialogActions>
      </Dialog>
    );
  }

  renderRlOverrideDialog() {
    const { open, form } = this.state.rlOverrideDialog;
    if (!open) return null;
    const { data } = this.props;
    const set = (k, v) => this.setState((s) => ({
      rlOverrideDialog: { ...s.rlOverrideDialog, form: { ...s.rlOverrideDialog.form, [k]: v } },
    }));
    return (
      <Dialog open onClose={this.closeRlOverrideDialog} maxWidth="sm" fullWidth>
        <DialogTitle>Add tenant override — {data?.name}</DialogTitle>
        <DialogContent>
          <TextField fullWidth margin="dense" label="Scope" value={form.scope}
            onChange={(e) => set("scope", e.target.value)}
            helperText="e.g. ingress.sms / ingress.ui / egress.sms.<operator>" />
          <TextField fullWidth margin="dense" type="number" label="Capacity (per IP)" value={form.capacity}
            onChange={(e) => set("capacity", e.target.value)} />
          <TextField fullWidth margin="dense" type="number" label="Fill rate" value={form.fillRate}
            onChange={(e) => set("fillRate", e.target.value)} />
          <TextField fullWidth margin="dense" type="number" label="Fill interval (seconds)" value={form.fillIntervalSecs}
            onChange={(e) => set("fillIntervalSecs", e.target.value)} />
          <TextField fullWidth margin="dense" label="Expires at (RFC3339, optional)" value={form.expiresAt}
            onChange={(e) => set("expiresAt", e.target.value)}
            placeholder="2026-12-31T23:59:59Z" />
          <TextField fullWidth margin="dense" multiline label="Reason" value={form.reason}
            onChange={(e) => set("reason", e.target.value)} />
        </DialogContent>
        <DialogActions>
          <Button onClick={this.closeRlOverrideDialog}>Cancel</Button>
          <Button onClick={this.submitRlOverride} variant="contained">Save</Button>
        </DialogActions>
      </Dialog>
    );
  }

  renderDeleteHeaderDialog() {
    const { deleteHeaderTarget, deleteHeaderBusy } = this.state;
    if (!deleteHeaderTarget) return null;
    const templates = this.templatesForHeader(deleteHeaderTarget);
    return (
      <Dialog open onClose={this.closeDeleteHeader} maxWidth="xs" fullWidth>
        <DialogTitle>
          Delete header "{deleteHeaderTarget.senderId}"?
        </DialogTitle>
        <DialogContent>
          {templates.length > 0 ? (
            <>
              <Alert severity="warning" sx={{ mb: 1 }}>
                {templates.length === 1
                  ? "The following template uses this header and will be deleted along with it:"
                  : `The following ${templates.length} templates use this header and will be deleted along with it:`}
              </Alert>
              <ul style={{ margin: 0, paddingLeft: 20, fontSize: 14 }}>
                {templates.map((tpl) => (
                  <li key={tpl.id}>
                    {tpl.templateName || tpl.template_name || tpl.id}
                    {(tpl.dltTemplateId || tpl.dlt_template_id) ? (
                      <span style={{ color: "#999", fontSize: 12 }}>
                        {" "}
                        (DLT: {tpl.dltTemplateId || tpl.dlt_template_id})
                      </span>
                    ) : null}
                  </li>
                ))}
              </ul>
            </>
          ) : (
            <Typography variant="body2">
              No templates use this header. This action cannot be undone.
            </Typography>
          )}
        </DialogContent>
        <DialogActions>
          {deleteHeaderBusy ? <CircularProgress size={20} /> : null}
          <Button onClick={this.closeDeleteHeader} disabled={deleteHeaderBusy}>
            Cancel
          </Button>
          <Button
            variant="contained"
            color="error"
            onClick={this.confirmDeleteHeader}
            disabled={deleteHeaderBusy}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  render() {
    let { data, tenantSmsConfig } = this.props;
    let {
      status,
      senderId,
      senderIds,
      dltPrincipalEntityId,
      showAddBalance,
      showChangeStatus,
      showAddSenderId,
      showChangeDefaultSenderId,
      showAddSMSType,
      showChangePassword,
      showEditDLTId,
      showClearDLTId,
    } = { ...data, ...this.state };
    const smsConfigResp = tenantSmsConfig?.data || tenantSmsConfig || {};
    const smsConfig = smsConfigResp.data || smsConfigResp;
    // Projects / Rate Limits / Routing are platform-infrastructure tabs
    // (SMSC routes, tier overrides, cross-project grants) — true platform
    // admins only. Support/admin agents keep the customer-facing tabs.
    const isPlatformAdmin = isPlatformAdminRole(this.props.userRole);
    const showNotifications = canViewNotifications(this.props.userRole);

    return (
      <div>
        <Dialog
          open={true}
          onClose={this.props.closeDetails}
          maxWidth="lg"
          fullWidth
          PaperProps={{ sx: { minHeight: "70vh" } }}
        >
          {/* Business name stays in the fixed title above every tab, so
              support always sees which account is open. Customer (contact)
              name is the secondary line, same as the list. */}
          <DialogTitle sx={{ pb: 1, position: "sticky", top: 0, zIndex: 2, bgcolor: "background.paper" }}>
            <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
              <Business fontSize="small" color="action" />
              <span style={{ fontWeight: 600 }}>{data.name || data.tenantName || "(no business name)"}</span>
              {(isAdminPanelRole(this.props.userRole) || isSupportTierRole(this.props.userRole)) && (
                <Tooltip title="Edit business name">
                  <IconButton size="small" onClick={this.openOrgNameDialog} aria-label="edit business name">
                    <EditIcon sx={{ fontSize: 16 }} />
                  </IconButton>
                </Tooltip>
              )}
            </div>
            <Typography variant="caption" sx={{ color: "text.secondary", display: "block", mt: 0.5 }}>
              {(data.contactName || data.onboarding?.contactName) && (
                <span>{data.contactName || data.onboarding?.contactName} · </span>
              )}
              {data.instituteId && <span>ID: <code>{data.instituteId}</code></span>}
            </Typography>
          </DialogTitle>
          <DialogContent dividers style={{ padding: 0 }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tabs
                value={this.state.activeTab}
                onChange={this.handleTabChange}
              >
                {/* Explicit values so the *_TAB_INDEX constants stay valid
                    when the platform-only tabs are hidden (MUI otherwise
                    numbers tabs by position). Display order is ops-first
                    (SMS Config / Billing lead); values match display order. */}
                <Tab label="SMS Config" value={0} />
                <Tab label="Billing" value={1} />
                {isPlatformAdmin && <Tab label="Account" value={2} />}
                <Tab label="Users" value={3} />
                <Tab label="Onboarding" value={4} />
                <Tab label="Webhooks" value={5} />
                {isPlatformAdmin && <Tab label="Projects" value={PROJECTS_TAB_INDEX} />}
                {isPlatformAdmin && <Tab label="Rate Limits" value={RATE_LIMITS_TAB_INDEX} />}
                {isPlatformAdmin && <Tab label="API Keys" value={API_KEYS_TAB_INDEX} />}
                {isPlatformAdmin && <Tab label="Routing" value={ROUTING_TAB_INDEX} />}
                {showNotifications && <Tab label="Notifications" value={NOTIFICATIONS_TAB_INDEX} />}
              </Tabs>
            </Box>
            <Box sx={{ p: 2 }}>
              {this.state.activeTab === 0 && this.renderSmsConfigTab()}
              {this.state.activeTab === 1 && this.renderBillingTab()}
              {isPlatformAdmin && this.state.activeTab === 2 && this.renderAccountTab()}
              {this.state.activeTab === 3 && this.renderUsersTab()}
              {this.state.activeTab === 4 && this.renderOnboardingTab()}
              {this.state.activeTab === 5 && this.renderWebhooksTab()}
              {isPlatformAdmin && this.state.activeTab === PROJECTS_TAB_INDEX && this.renderProjectsTab()}
              {isPlatformAdmin && this.state.activeTab === RATE_LIMITS_TAB_INDEX && this.renderRateLimitsTab()}
              {isPlatformAdmin && this.state.activeTab === API_KEYS_TAB_INDEX && (
                <AdminApiKeysTab tenantId={data?.instituteId} />
              )}
              {isPlatformAdmin && this.state.activeTab === ROUTING_TAB_INDEX && (
                <AdminRoutingTab tenantId={data?.instituteId} />
              )}
              {showNotifications && this.state.activeTab === NOTIFICATIONS_TAB_INDEX && (
                <SentEmailsTab orgId={data?.instituteId} />
              )}
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.props.closeDetails}>Close</Button>
          </DialogActions>
        </Dialog>
        {showAddBalance ? (
          <AddBalance
            data={data}
            addBalance={this.addBalance}
            closeAddBalance={this.closeAddBalance}
          />
        ) : null}
        {showChangeStatus ? (
          <ChangeStatus
            status={status}
            changeStatus={this.changeStatus}
            closeChangeStatus={this.closeChangeStatus}
          />
        ) : null}
        {showAddSenderId ? (
          <AddSenderId
            addSenderId={this.addSenderId}
            closeAddSenderId={this.closeAddSenderId}
          />
        ) : null}
        {showEditDLTId ? (
          <EditDLT
            toggleEditDLTId={this.toggleEditDLTId}
            onSuccess={this.onDltUpdateSuccess}
            tenantId={data.instituteId}
            dltPrincipalEntityId={dltPrincipalEntityId}
          />
        ) : null}
        {showClearDLTId ? (
          <ClearDLT
            onClose={this.toggleClearDLTId}
            onSuccess={this.onDltUpdateSuccess}
            tenantId={data.instituteId}
            tenantName={data.name || data.tenantName}
            // Same source as the DLT ID row (sms config first), so the typed
            // confirmation matches what the panel shows.
            dltPrincipalEntityId={
              smsConfig.dltPrincipalEntityId ||
              smsConfig.dlt_principal_entity_id ||
              dltPrincipalEntityId
            }
          />
        ) : null}
        {this.state.editTmdTarget ? (
          <EditSenderIdTmd
            onClose={this.closeEditSenderIdTmd}
            onSuccess={this.onSenderIdTmdUpdateSuccess}
            tenantId={data.instituteId}
            senderId={
              this.state.editTmdTarget.senderId ||
              this.state.editTmdTarget.sender_id
            }
            dltTmdId={
              this.state.editTmdTarget.dltTmdId ||
              this.state.editTmdTarget.dlt_tmd_id ||
              ""
            }
            dltTmdMode={
              this.state.editTmdTarget.dltTmdMode ||
              this.state.editTmdTarget.dlt_tmd_mode ||
              ""
            }
          />
        ) : null}
        {showChangeDefaultSenderId ? (
          <ChangeDefaultSenderId
            senderIds={senderIds}
            senderId={senderId}
            changeDefaultSenderId={this.changeDefaultSenderId}
            closeChangeDefaultSenderId={this.closeChangeDefaultSenderId}
          />
        ) : null}
        {showAddSMSType ? (
          <AddSMSType
            data={data}
            addSMSType={this.addSMSType}
            closeAddSMSType={this.closeAddSMSType}
          />
        ) : null}
        {showChangePassword && (
          <ChangePassword
            data={data}
            changePassword={this.changePassword}
            closeChangePassword={this.closeChangePassword}
          />
        )}
        {this.renderDeleteHeaderDialog()}
        {this.renderRlTierDialog()}
        {this.renderRlOverrideDialog()}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    userRole: getFromLocalStorage().role,
    tenantUsersRes: state.adminPanel.tenantUsersResponse,
    adminWallets: state.billing.adminWallets,
    adminTransactions: state.billing.adminTransactions,
    adminPlans: state.billing.adminPlans,
    adminSubscription: state.billing.adminSubscription,
    adminBillingSetup: state.billing.adminBillingSetup,
    accountStatus: state.lifecycle.accountStatus,
    statusHistory: state.lifecycle.statusHistory,
    accountSubscriptions: state.lifecycle.accountSubscriptions,
    accountEntitlements: state.lifecycle.accountEntitlements,
    tenantSmsConfig: state.adminPanel.tenantSmsConfigResponse,
    adminTemplates: state.adminPanel.adminTemplatesResponse,
    tenantRateLimit: state.rateLimit.getTenantResponse,
  };
}

export default connect(mapStateToProps, {
  adminGetCustomerWallets,
  adminGetCustomerTransactions,
  adminCreateWallets,
  adminCreateCustomWallet,
  adminTopUpWallet,
  adminTerminateWallet,
  adminListPlans,
  adminCreatePlan,
  adminUpdatePlan,
  adminDeletePlan,
  adminGetSubscription,
  adminChangeSubscription,
  adminGetBillingSetup,
  adminRunBillingSetup,
  adminRunSmsConfigSetup,
  adminRunLifecycleSetup,
  adminEditWallet,
  adminVoidWalletCredits,
  getAccountStatus,
  getStatusHistory,
  getAccountSubscriptions,
  getAccountEntitlements,
  transitionAccount,
  getTenantSmsConfig,
  changeDefaultSenderId,
  setDefaultSmsType,
  adminListTemplates,
  adminCreateTemplate,
  adminUpdateTemplate,
  adminDeleteTemplate,
  getTenantRateLimit,
  setTenantTier,
  setTenantOverride,
  removeTenantOverride,
})(CustomerDetails);
